<template>
  <div @click="onButtonClick($event)" class="usa-link border-base-lightest border-2px display-flex flex-column height-full minh-15 padding-x-2 padding-y-3 radius-md shadow-1 text-center text-no-underline hover:text-underline">
   
    <span class="svg-lg text-black" v-html="data.fields.cardsvg"></span>
    <!-- <span class="svg-lg text-black" v-if="data.fields.iconCode == 'info'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="105.000000pt" height="100.000000pt" viewBox="0 0 105.000000 100.000000"
      preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M94 990 c-12 -4 -31 -21 -43 -36 -21 -26 -21 -32 -21 -461 l0 -435
      29 -29 29 -29 436 0 436 0 32 29 33 29 3 421 c2 355 0 426 -12 456 -27 64 -35
      65 -493 64 -224 0 -418 -4 -429 -9z m878 -48 l23 -23 0 -425 0 -426 -24 -19
      c-22 -18 -45 -19 -444 -19 -418 0 -421 0 -444 22 l-23 21 0 422 c0 454 0 458
      53 468 12 3 205 4 429 3 l407 -1 23 -23z" stroke-width="18"   stroke="black" />
      <path d="M495 819 c-50 -28 -60 -82 -22 -117 32 -30 81 -29 112 3 31 30 32 57
      3 89 -27 30 -65 40 -93 25z m49 -25 c48 -18 38 -84 -12 -84 -49 0 -67 37 -35
      72 18 20 23 21 47 12z" stroke-width="18"   stroke="black" />
      <path d="M500 613 c-36 -9 -71 -17 -77 -19 -24 -6 -15 -50 12 -62 l26 -12 -3
      -147 -3 -147 -25 -6 c-18 -4 -25 -13 -25 -30 l0 -25 126 -3 c111 -2 127 -1
      133 14 7 19 -1 31 -36 48 -23 11 -23 14 -26 196 -2 169 -9 213 -31 209 -3 -1
      -35 -8 -71 -16z m70 -203 c0 -167 1 -181 20 -200 l20 -20 -81 0 c-79 0 -81 1
      -60 18 21 16 22 24 19 177 -3 156 -4 160 -26 171 -22 11 -21 12 25 22 91 19
      83 35 83 -168z" stroke-width="18" stroke="black" />
      </g>
      </svg>
    </span>
    
  <span class="svg-lg text-black" v-if="data.fields.iconCode == 'cross-tray'">
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="100.000000pt" height="100.000000pt" viewBox="0 0 100.000000 100.000000"
      preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
    fill="#000000" stroke="none">
    <path d="M158 823 l-136 -138 -7 -199 -7 -199 143 -143 144 -144 205 0 205 0
    138 138 137 137 0 199 0 198 -136 144 -136 144 -207 0 -206 0 -137 -137z m660
    -29 l132 -137 0 -181 0 -181 -132 -132 -133 -133 -185 0 -185 0 -133 133 -132
    132 0 185 0 185 132 132 133 133 185 0 185 0 133 -136z" stroke-width="18" stroke="black" />
    <path d="M472 805 c-13 -17 -30 -25 -49 -25 -30 0 -55 -20 -66 -52 -4 -11 -17
    -18 -31 -18 -13 0 -34 -9 -47 -19 -21 -17 -24 -29 -27 -98 -2 -43 1 -145 6
    -227 l8 -149 42 -37 c50 -45 114 -65 203 -64 105 0 146 27 256 164 94 117 111
    158 81 188 -26 26 -127 4 -141 -30 -3 -7 -6 56 -6 140 -1 150 -1 153 -27 179
    -19 19 -33 24 -55 21 -18 -3 -29 0 -29 7 0 21 -36 45 -68 45 -21 0 -37 -8 -50
    -25z m76 -17 c8 -8 12 -50 12 -125 l0 -113 -35 0 -35 0 0 113 c0 110 7 137 35
    137 6 0 16 -5 23 -12z m-98 -57 c5 -11 10 -55 10 -99 0 -74 -2 -80 -22 -86
    -47 -12 -48 -11 -48 87 0 92 8 117 37 117 7 0 17 -9 23 -19z m210 -170 l0
    -168 -46 -13 c-52 -15 -114 -69 -114 -100 0 -30 23 -24 42 10 18 32 70 60 109
    60 14 0 39 18 65 46 33 35 51 46 76 47 22 1 33 -3 35 -13 5 -21 -176 -242
    -212 -259 -80 -39 -235 -18 -290 39 l-30 31 0 212 0 212 24 3 c32 5 41 -12 41
    -80 0 -47 -4 -59 -20 -68 -11 -6 -20 -17 -20 -25 0 -8 1 -15 3 -15 1 0 25 7
    52 16 35 10 80 14 149 12 75 -2 100 0 104 10 2 7 -5 16 -17 19 -20 5 -21 9
    -15 102 7 99 15 116 46 100 16 -9 18 -26 18 -178z" stroke-width="18" stroke="black" />
    </g>
    </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'professional'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="96.000000pt" height="110.000000pt" viewBox="0 0 96.000000 110.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M405 1075 c-51 -18 -101 -72 -115 -124 -13 -51 2 -226 24 -269 19
      -36 69 -80 102 -88 44 -11 133 2 161 22 66 49 82 99 83 247 0 109 -10 138 -60
      180 -54 46 -124 57 -195 32z m156 -40 c58 -31 70 -66 67 -195 -4 -130 -18
      -168 -71 -200 -66 -41 -171 -19 -212 44 -22 33 -39 214 -25 265 25 93 144 136
      241 86z" stroke-width="18" stroke="black" />
      <path d="M229 546 c-117 -41 -135 -50 -151 -79 -13 -24 -58 -284 -50 -292 3
      -3 41 -5 84 -5 71 0 78 -2 78 -20 0 -18 -7 -20 -60 -20 -47 0 -60 -3 -60 -15
      0 -12 13 -15 59 -15 57 0 59 -1 70 -30 l10 -30 268 2 268 3 3 28 c3 26 5 27
      68 27 50 0 64 3 64 15 0 12 -13 15 -60 15 -53 0 -60 2 -60 20 0 18 7 20 80 20
      94 0 89 -13 61 161 -27 168 -21 160 -185 215 l-101 34 -70 -49 -70 -49 -70 49
      c-39 27 -72 49 -75 48 -3 0 -48 -15 -101 -33z m92 -84 c-72 -1 -130 -7 -138
      -14 -13 -10 -12 -97 3 -210 l4 -38 -65 0 c-37 0 -65 4 -65 10 0 28 32 208 41
      231 12 32 29 41 139 78 l85 28 60 -41 60 -41 -124 -3z m404 52 c115 -38 124
      -49 146 -186 10 -62 19 -116 19 -120 0 -5 -29 -8 -65 -8 l-65 0 6 93 c3 50 7
      101 9 111 2 11 0 28 -6 38 -9 16 -24 18 -141 18 l-131 0 54 40 c30 21 63 39
      74 40 11 0 56 -12 100 -26z m21 -101 c-2 -10 -7 -76 -11 -148 -3 -72 -9 -145
      -12 -163 l-5 -32 -247 2 -246 3 -7 105 c-3 58 -9 138 -12 178 l-6 72 276 0
      c257 0 275 -1 270 -17z" stroke-width="18" stroke="black" />
      <path d="M429 325 c-38 -20 -52 -67 -35 -110 38 -91 166 -65 166 34 0 32 -6
      44 -31 65 -34 29 -61 32 -100 11z m83 -32 c37 -34 13 -103 -36 -103 -52 0 -78
      52 -45 93 23 31 54 35 81 10z" stroke-width="18" stroke="black" />
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'briefcase'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="105.000000pt" height="82.000000pt" viewBox="0 0 105.000000 82.000000"
      preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,82.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M386 794 c-9 -8 -16 -26 -16 -39 0 -23 0 -23 -151 -27 -194 -4 -189
      1 -189 -173 0 -107 2 -125 20 -148 18 -23 20 -40 20 -177 0 -147 1 -152 25
      -175 l24 -25 414 0 c404 0 415 1 441 21 l26 20 0 155 c0 141 2 156 20 174 18
      18 20 33 20 153 0 177 7 171 -186 175 -128 3 -144 5 -144 21 0 9 -7 27 -16 39
      -14 21 -22 22 -154 22 -113 0 -142 -3 -154 -16z m282 -26 c33 -33 15 -38 -128
      -38 -129 0 -140 1 -140 18 0 10 3 22 7 25 12 13 248 8 261 -5z m340 -207 c2
      -77 -1 -128 -8 -136 -6 -7 -41 -18 -78 -24 -37 -7 -75 -14 -84 -17 -13 -4 -17
      3 -20 28 -3 33 -3 33 -58 33 l-55 0 -3 -42 c-3 -47 -2 -46 -104 -63 -64 -11
      -88 -9 -205 15 -18 4 -22 13 -25 48 -3 42 -3 42 -46 45 -50 4 -72 -10 -72 -45
      0 -18 -4 -23 -17 -19 -10 3 -47 10 -83 17 -36 6 -71 19 -77 27 -17 21 -18 233
      -1 250 9 9 123 12 473 10 l460 -3 3 -124z m-668 -216 c0 -63 -1 -65 -25 -65
      -24 0 -25 2 -25 65 0 63 1 65 25 65 24 0 25 -2 25 -65z m450 0 l0 -65 -30 0
      -30 0 0 65 0 65 30 0 30 0 0 -65z m-597 15 l57 -11 0 -43 c0 -54 16 -68 72
      -64 42 3 43 4 46 42 l3 39 47 -7 c109 -16 151 -17 214 -3 l67 14 3 -41 c3 -39
      5 -41 37 -44 19 -2 44 -1 57 2 21 6 24 12 24 55 l0 50 58 11 c31 6 65 12 75
      14 16 4 17 -7 15 -147 l-3 -152 -424 -3 c-333 -2 -426 0 -433 10 -9 15 -11
      282 -2 291 3 3 11 4 17 2 7 -2 38 -9 70 -15z" stroke-width="18" stroke="black"/>
      </g>
      </svg>
    </span>
    
     <span class="svg-lg text-black" v-if="data.fields.iconCode == 'faqevisa'">
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="110.000000pt" height="100.000000pt" viewBox="0 0 110.000000 100.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M253 986 c-135 -44 -229 -152 -240 -276 -7 -79 10 -125 74 -191 l54
-57 -21 -35 c-14 -24 -19 -43 -14 -61 7 -29 48 -66 73 -66 10 0 22 -14 30 -35
12 -34 53 -65 86 -65 8 0 15 -7 15 -16 0 -23 55 -74 79 -74 14 0 23 -8 27 -25
8 -34 50 -65 86 -65 31 0 112 66 123 101 6 18 8 18 36 3 18 -9 39 -12 52 -8
31 9 67 44 67 66 0 13 8 18 30 18 36 0 80 39 80 70 0 13 7 20 20 20 48 0 87
77 61 119 -7 11 3 28 35 65 66 72 78 101 78 176 1 84 -33 159 -105 235 -74 78
-143 110 -239 110 -82 0 -134 -20 -179 -69 -14 -14 -30 -26 -36 -26 -6 0 -22
12 -36 26 -56 60 -157 86 -236 60z m167 -46 c19 -10 46 -30 59 -44 l25 -27
-77 -77 c-42 -43 -77 -85 -77 -94 0 -9 12 -26 28 -38 22 -18 37 -21 79 -18 46
4 59 10 102 51 28 26 57 47 66 47 9 0 45 -7 80 -16 72 -18 121 -13 156 15 36
29 15 41 -32 18 -40 -20 -43 -20 -113 -3 -99 23 -111 21 -159 -23 -23 -21 -52
-43 -64 -50 -30 -15 -75 -14 -99 3 -18 14 -14 20 86 121 58 59 123 117 146
131 120 71 276 18 373 -128 80 -119 77 -207 -11 -303 l-51 -56 -119 125 c-106
112 -148 145 -148 118 0 -5 63 -75 140 -156 77 -80 140 -152 140 -159 0 -21
-30 -57 -48 -57 -9 0 -54 37 -99 82 -67 67 -83 79 -89 64 -5 -12 14 -38 70
-95 42 -43 76 -84 76 -92 0 -20 -31 -49 -54 -49 -13 0 -50 29 -96 75 -70 70
-100 90 -100 64 0 -5 32 -43 70 -84 73 -77 77 -84 60 -116 -19 -34 -61 -24
-110 26 -24 25 -50 45 -56 45 -8 0 -10 12 -7 37 4 29 0 45 -17 66 -12 15 -27
27 -34 27 -10 0 -12 12 -9 44 5 38 2 48 -20 70 -29 29 -71 34 -103 12 -19 -13
-22 -12 -48 20 -38 47 -81 47 -135 -1 l-39 -35 -51 55 c-95 105 -93 215 6 325
91 102 203 131 303 80z m-106 -442 c9 -12 16 -26 16 -31 0 -16 -123 -137 -138
-137 -23 0 -52 30 -52 54 0 28 108 136 137 136 12 0 29 -10 37 -22z m148 -35
c34 -31 22 -56 -71 -146 -49 -48 -93 -87 -97 -87 -5 0 -20 7 -32 16 -42 29
-29 60 61 151 46 46 92 83 102 83 10 0 27 -7 37 -17z m62 -139 c9 -8 16 -25
16 -36 0 -25 -119 -148 -143 -148 -21 0 -57 35 -57 56 0 9 28 45 62 80 64 67
92 78 122 48z m63 -136 c13 -12 23 -25 23 -30 0 -16 -92 -108 -108 -108 -23 0
-52 30 -52 54 0 23 77 106 99 106 8 0 25 -10 38 -22z"/>
</g>
</svg>
    </span>



    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'student'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="96.000000pt" height="110.000000pt" viewBox="0 0 96.000000 110.000000"
      preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M310 1002 c-80 -36 -147 -68 -150 -69 -2 -2 1 -13 8 -23 14 -23 16
      -126 3 -134 -5 -3 -9 -38 -9 -76 l-1 -71 37 3 36 3 1 63 c1 37 -4 71 -12 80
      -11 15 -19 102 -9 102 1 0 17 -5 33 -10 l30 -11 6 -140 c6 -159 25 -216 85
      -256 67 -44 170 -39 230 12 48 41 63 94 69 246 l6 136 58 25 c33 15 59 32 59
      40 -1 14 -294 149 -320 147 -8 0 -80 -30 -160 -67z m293 -18 c70 -32 127 -60
      127 -63 0 -4 -57 -32 -127 -64 l-128 -57 -127 57 c-71 32 -128 60 -128 63 0 5
      232 116 250 119 3 1 62 -24 133 -55z m-177 -194 l51 -23 79 36 79 36 3 -30 c5
      -45 -1 -54 -54 -80 -67 -32 -155 -31 -220 2 -46 23 -49 28 -52 67 l-3 43 33
      -15 c18 -8 56 -24 84 -36z m-216 -40 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10
      0 6 5 10 10 10 6 0 10 -4 10 -10z m155 -55 c59 -27 167 -26 225 2 24 13 46 21
      48 19 10 -10 -17 -166 -33 -190 -25 -38 -72 -60 -130 -60 -63 0 -112 26 -136
      74 -18 36 -37 185 -22 178 4 -2 26 -12 48 -23z m-168 -27 c-3 -8 -6 -5 -6 6
      -1 11 2 17 5 13 3 -3 4 -12 1 -19z" stroke-width="18" stroke="black"/>
      <path d="M213 387 c-131 -45 -140 -56 -164 -203 -10 -65 -19 -131 -19 -146 l0
      -28 445 0 445 0 0 28 c0 15 -9 81 -19 146 -25 148 -34 160 -171 205 -52 17
      -101 31 -108 31 -7 0 -43 -21 -81 -46 l-68 -45 -66 45 c-35 25 -73 46 -83 45
      -11 0 -61 -15 -111 -32z m192 -46 l70 -48 73 49 73 49 97 -32 c53 -17 106 -40
      116 -50 14 -13 24 -50 37 -131 10 -62 19 -119 19 -125 0 -10 -90 -13 -415 -13
      -325 0 -415 3 -415 13 1 57 40 241 54 255 15 15 185 80 211 81 6 0 41 -22 80
      -48z" stroke-width="18" stroke="black"/>
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'exchange arrows'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="142.000000pt" height="110.000000pt" viewBox="0 0 142.000000 110.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M588 1064 c-95 -22 -177 -70 -254 -148 -78 -79 -114 -142 -142 -253
l-18 -71 -59 74 c-55 68 -85 90 -85 63 0 -17 152 -194 165 -193 20 2 195 147
195 161 0 23 -16 14 -100 -53 l-82 -67 7 44 c33 203 186 366 386 414 201 47
409 -29 530 -195 44 -61 59 -72 59 -44 0 24 -54 97 -110 147 -127 115 -322
163 -492 121z" stroke-width="18"   stroke="black"/>
<path d="M1137 484 c-86 -69 -116 -104 -88 -104 5 0 46 30 91 66 l82 67 -7
-44 c-28 -165 -139 -311 -293 -381 -223 -102 -489 -24 -638 187 -12 17 -25 26
-30 22 -25 -24 115 -176 204 -221 94 -47 152 -61 257 -61 78 0 115 5 167 23
180 62 310 205 356 394 l17 69 60 -75 c56 -71 85 -92 85 -63 0 12 -144 190
-158 195 -5 1 -52 -32 -105 -74z" stroke-width="18"   stroke="black"/>
</g>
</svg>

    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'ship'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="110.000000pt" height="110.000000pt" viewBox="0 0 110.000000 110.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M525 1048 c-2 -7 -6 -35 -7 -63 -2 -41 -7 -50 -23 -53 -41 -8 -55
-32 -55 -94 l0 -58 -91 0 c-133 0 -129 5 -129 -150 l0 -130 -56 -28 c-54 -26
-55 -27 -49 -62 13 -77 37 -140 69 -188 l33 -50 -24 -11 c-35 -16 -68 -13
-110 9 -45 24 -73 26 -73 5 0 -8 6 -15 13 -15 7 0 29 -9 50 -20 20 -11 53 -20
72 -20 20 0 53 9 75 20 49 25 61 25 110 0 50 -25 100 -25 147 0 21 11 45 20
53 20 8 0 32 -9 53 -20 47 -25 97 -25 147 0 49 25 61 25 110 0 47 -24 102 -26
138 -5 15 8 40 19 55 25 29 10 28 30 -1 30 -10 0 -34 -9 -55 -20 -43 -23 -85
-26 -112 -6 -18 13 -19 16 -4 33 36 40 89 181 89 235 0 8 -22 25 -49 38 l-49
23 -4 127 c-2 89 -7 132 -17 143 -11 14 -33 17 -112 17 l-99 0 0 59 c0 64 -15
91 -51 91 -17 0 -19 7 -19 59 0 56 -14 89 -25 59z m63 -210 l3 -58 -61 0 -60
0 0 53 c0 30 3 57 7 61 4 4 30 6 58 4 l50 -3 3 -57z m220 -206 l3 -114 -23 8
c-13 3 -71 31 -130 60 -59 30 -116 54 -126 54 -11 0 -74 -27 -141 -60 -67 -33
-126 -60 -132 -60 -10 0 -13 213 -2 223 4 4 128 6 277 5 l271 -3 3 -113z
m-288 -235 l0 -202 -47 -23 c-57 -27 -83 -28 -126 -5 -18 9 -50 19 -72 22 -35
5 -43 12 -72 60 -18 30 -39 81 -46 115 l-14 61 176 87 c97 47 182 87 189 87 9
1 12 -46 12 -202z m224 114 c169 -81 175 -85 170 -110 -14 -66 -38 -128 -65
-168 -24 -34 -36 -43 -60 -43 -16 0 -47 -9 -69 -20 -50 -25 -79 -25 -130 1
l-40 21 0 205 c0 114 4 203 9 201 5 -1 88 -41 185 -87z" stroke-width="10"   stroke="black"/>
<path d="M17 83 c-14 -13 -6 -33 13 -33 11 0 34 -9 52 -20 42 -25 95 -25 133
0 38 25 82 25 120 0 38 -25 96 -25 137 0 42 25 79 25 120 0 42 -25 95 -25 133
0 38 25 82 25 120 0 38 -25 96 -25 137 0 18 11 41 20 51 20 10 0 17 8 17 20 0
26 -17 25 -74 -5 -56 -30 -71 -31 -111 -7 -55 34 -82 35 -142 7 -68 -31 -71
-31 -129 0 -26 14 -55 25 -64 25 -9 0 -38 -11 -64 -25 -58 -31 -66 -31 -124 0
-58 31 -65 31 -127 0 -61 -30 -78 -31 -119 -6 -39 23 -70 33 -79 24z" stroke-width="10"   stroke="black"/>
</g>
</svg>

    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'joined hands'">
     <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="123.000000pt" height="123.000000pt" viewBox="0 0 123.000000 123.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,123.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M440 1159 c0 -44 -7 -65 -45 -130 -25 -43 -45 -83 -45 -89 0 -25 26
-1 60 54 19 32 40 58 45 59 6 0 26 -28 45 -61 19 -34 41 -62 48 -62 20 0 15
15 -32 95 -35 58 -46 87 -48 127 -4 71 -28 78 -28 7z"/>
<path d="M390 845 l0 -105 -39 0 c-22 0 -42 -4 -45 -9 -4 -5 3 -30 14 -56 18
-41 20 -69 20 -241 l0 -194 -46 0 -46 0 3 98 4 97 -80 0 -80 0 2 -30 c2 -16 6
-60 9 -97 l7 -67 -34 -3 -34 -3 -3 -102 -3 -103 566 0 565 0 0 214 c0 180 2
216 15 226 12 10 15 28 13 63 -4 64 -28 78 -28 17 0 -23 -4 -40 -8 -38 -4 2
-54 52 -110 112 l-102 109 0 64 c0 47 -3 64 -12 61 -8 -3 -14 -29 -16 -69 l-3
-64 -97 3 -97 3 -72 -78 -72 -78 -1 43 c0 24 7 56 15 73 20 38 13 49 -36 49
l-39 0 0 105 0 105 -65 0 -65 0 0 -105z m100 -15 l0 -90 -35 0 -35 0 0 90 0
90 35 0 35 0 0 -90z m71 -142 c-8 -21 -15 -23 -102 -26 -79 -2 -96 0 -106 15
-7 9 -13 20 -13 25 0 4 52 8 115 8 l114 0 -8 -22z m291 -35 c-22 -27 -66 -73
-96 -103 l-56 -54 0 47 c0 35 -4 47 -15 47 -11 0 -15 -12 -15 -50 l0 -50 -61
0 -61 0 33 38 c19 20 61 67 94 105 l60 67 78 0 79 0 -40 -47z m184 -161 c-53
-1 -140 -1 -193 0 l-98 3 95 103 95 102 99 -102 98 -103 -96 -3z m-486 92 c0
-35 -6 -54 -25 -76 -22 -26 -25 -39 -25 -109 l0 -79 -65 0 -65 0 0 155 0 155
90 0 90 0 0 -46z m140 -324 l0 -200 -80 0 -80 0 0 200 0 200 80 0 80 0 0 -200z
m450 0 l0 -200 -210 0 -210 0 0 200 0 200 210 0 210 0 0 -200z m-914 128 c-3
-13 -6 -26 -6 -30 0 -5 -20 -8 -45 -8 -43 0 -45 1 -45 30 0 29 1 30 51 30 48
0 51 -1 45 -22z m-6 -108 l0 -40 -40 0 -40 0 0 40 0 40 40 0 40 0 0 -40z m280
-105 l0 -115 -65 0 -65 0 0 115 0 115 65 0 65 0 0 -115z m-160 -40 l0 -75
-135 0 -135 0 0 75 0 75 135 0 135 0 0 -75z"/>
<path d="M924 575 c-8 -19 2 -45 16 -45 5 0 10 14 10 30 0 31 -16 41 -26 15z"/>
<path d="M420 400 c0 -16 5 -30 10 -30 6 0 10 14 10 30 0 17 -4 30 -10 30 -5
0 -10 -13 -10 -30z"/>
<path d="M817 413 c-4 -3 -7 -21 -7 -40 0 -23 5 -33 15 -33 9 0 15 9 15 25 0
23 4 25 40 25 36 0 40 -2 40 -26 0 -31 24 -28 28 5 3 19 9 22 40 19 30 -2 38
-8 40 -25 6 -39 22 -25 22 17 l0 40 -113 0 c-63 0 -117 -3 -120 -7z"/>
<path d="M814 286 c-8 -21 -1 -61 11 -61 6 0 11 10 13 23 3 18 10 22 43 22 35
0 39 -2 39 -26 0 -31 23 -28 28 4 3 18 10 22 43 22 35 0 39 -3 39 -25 0 -14 5
-25 10 -25 6 0 10 18 10 40 l0 40 -115 0 c-91 0 -117 -3 -121 -14z"/>
<path d="M812 143 c3 -40 21 -48 26 -13 3 16 11 20 42 20 31 0 39 -4 42 -20 4
-29 22 -30 26 -2 3 18 10 22 43 22 32 0 39 -3 39 -20 0 -11 5 -20 10 -20 6 0
10 16 10 35 l0 35 -121 0 -120 0 3 -37z"/>
<path d="M420 155 c0 -19 5 -35 10 -35 6 0 10 16 10 35 0 19 -4 35 -10 35 -5
0 -10 -16 -10 -35z"/>
<path d="M166 633 c-3 -3 -6 -25 -6 -48 0 -36 -6 -47 -50 -90 -27 -27 -50 -53
-50 -57 0 -19 28 -5 70 37 l46 45 44 -45 c40 -41 70 -57 70 -37 0 4 -22 30
-50 57 -44 44 -50 54 -50 92 0 40 -10 60 -24 46z"/>
</g>
</svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'minus inside circle'">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="119.000000pt" height="100.000000pt" viewBox="0 0 119.000000 100.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M584 980 c-29 -11 -544 -868 -544 -904 0 -14 9 -35 20 -46 20 -20 33
-20 554 -20 l535 0 21 27 c12 15 20 37 18 48 -7 34 -497 847 -529 878 -31 29
-41 31 -75 17z m308 -460 c141 -234 257 -433 258 -442 0 -10 -9 -22 -19 -28
-13 -6 -196 -10 -524 -10 -540 0 -537 0 -524 49 5 21 457 779 494 829 14 19
32 32 41 30 10 -2 124 -181 274 -428z"/>
<path d="M555 666 c-17 -12 -18 -25 -12 -168 4 -85 9 -163 13 -172 8 -20 96
-23 111 -3 6 6 13 83 17 169 5 135 4 159 -10 172 -19 20 -93 21 -119 2z m90
-24 c6 -4 8 -61 5 -152 l-5 -145 -31 -3 -31 -3 -7 146 c-4 80 -4 150 -1 155 7
12 55 13 70 2z"/>
<path d="M585 258 c-26 -15 -35 -28 -35 -54 0 -51 84 -75 114 -32 22 31 20 45
-9 73 -27 28 -40 30 -70 13z m53 -52 c-2 -13 -12 -22 -26 -24 -29 -4 -42 26
-18 44 24 17 48 6 44 -20z"/>
</g>
</svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'refresh'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="91.000000pt" height="91.000000pt" viewBox="0 0 91.000000 91.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,91.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M161 863 c-7 -3 -40 -46 -72 -96 l-59 -91 0 -321 c0 -236 3 -324 12
-333 9 -9 116 -12 419 -12 361 0 409 2 424 16 14 14 15 53 13 333 l-3 316 -57
87 c-31 48 -66 91 -77 97 -20 11 -573 15 -600 4z m214 -70 c-14 -102 0 -93
-151 -93 -74 0 -134 3 -134 8 0 10 71 115 84 124 6 4 55 8 110 8 l98 0 -7 -47z
m138 25 c3 -13 9 -44 12 -70 l7 -48 -72 0 c-70 0 -72 1 -67 23 3 12 9 43 12
70 l7 47 48 0 c41 0 49 -3 53 -22z m239 10 c13 -11 57 -73 82 -115 6 -10 -23
-13 -132 -13 l-140 0 -7 48 c-3 26 -9 57 -12 70 -5 22 -4 22 94 22 64 0 105
-4 115 -12z m-394 -231 l3 -68 102 3 102 3 3 68 3 68 147 -3 147 -3 0 -310 0
-310 -402 -3 -403 -2 0 308 c0 170 3 312 7 316 4 3 70 5 147 4 l141 -3 3 -68z
m180 16 l3 -53 -75 0 -76 0 0 55 0 56 73 -3 72 -3 3 -52z"/>
<path d="M252 417 c-23 -23 -42 -46 -42 -51 0 -13 61 -86 81 -97 34 -18 36 18
3 52 l-29 30 187 -3 c178 -3 189 -4 210 -25 33 -33 30 -89 -6 -119 -26 -23
-34 -24 -177 -24 -126 0 -149 -2 -149 -15 0 -13 23 -15 151 -15 171 0 196 8
225 69 15 31 15 40 3 75 -9 25 -27 49 -48 63 -32 22 -43 23 -207 23 -96 0
-174 3 -174 7 0 4 9 17 21 29 19 20 19 44 0 44 -4 0 -26 -19 -49 -43z"/>
</g>
</svg>

    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'building'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="105.000000pt" height="110.000000pt" viewBox="0 0 105.000000 110.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M340 950 l0 -119 -142 -3 -143 -3 -3 -391 c-2 -381 -3 -392 -22 -397
      -11 -3 -20 -10 -20 -16 0 -8 148 -11 510 -11 447 0 510 2 510 15 0 8 -9 15
      -20 15 -19 0 -20 8 -22 512 l-3 513 -322 3 -323 2 0 -120z m618 -412 l2 -498
      -150 0 -150 0 0 49 c0 47 2 50 28 53 25 3 27 6 27 48 0 42 -2 45 -27 48 -26 3
      -28 7 -28 48 0 42 1 44 30 44 29 0 30 2 30 45 0 43 -1 45 -30 45 -29 0 -30 1
      -30 50 0 49 1 50 31 50 29 0 30 1 27 43 -3 38 -6 42 -30 45 -26 3 -28 7 -28
      47 0 40 2 44 28 47 25 3 27 6 27 48 0 40 -3 45 -25 48 -14 2 -29 10 -33 18 -6
      11 -38 14 -147 14 l-140 0 0 105 0 105 293 -2 292 -3 3 -497z m-338 -118 l0
      -380 -105 0 -105 0 0 89 c0 95 -3 101 -55 101 -52 0 -55 -6 -55 -101 l0 -89
      -105 0 -105 0 0 380 0 380 265 0 265 0 0 -380z m68 333 c-5 -25 -28 -28 -28
      -4 0 12 6 21 16 21 9 0 14 -7 12 -17z m2 -188 c0 -8 -7 -15 -15 -15 -8 0 -15
      7 -15 15 0 8 7 15 15 15 8 0 15 -7 15 -15z m0 -190 c0 -8 -7 -15 -15 -15 -8 0
      -15 7 -15 15 0 8 7 15 15 15 8 0 15 -7 15 -15z m0 -190 c0 -8 -7 -15 -15 -15
      -8 0 -15 7 -15 15 0 8 7 15 15 15 8 0 15 -7 15 -15z m-310 -70 c0 -73 -1 -75
      -25 -75 -24 0 -25 2 -25 75 0 73 1 75 25 75 24 0 25 -2 25 -75z"/>
      <path d="M417 984 c-4 -4 -7 -25 -7 -46 l0 -38 61 0 60 0 -3 43 -3 42 -50 3
      c-28 2 -54 0 -58 -4z m83 -39 c0 -10 -10 -15 -30 -15 -20 0 -30 5 -30 15 0 10
      10 15 30 15 20 0 30 -5 30 -15z"/>
      <path d="M607 984 c-4 -4 -7 -25 -7 -46 l0 -38 61 0 60 0 -3 43 -3 42 -50 3
      c-28 2 -54 0 -58 -4z m83 -39 c0 -10 -10 -15 -30 -15 -20 0 -30 5 -30 15 0 10
      10 15 30 15 20 0 30 -5 30 -15z"/>
      <path d="M787 984 c-4 -4 -7 -25 -7 -46 l0 -38 61 0 60 0 -3 43 -3 42 -50 3
      c-28 2 -54 0 -58 -4z m83 -39 c0 -10 -10 -15 -30 -15 -20 0 -30 5 -30 15 0 10
      10 15 30 15 20 0 30 -5 30 -15z"/>
      <path d="M787 794 c-4 -4 -7 -25 -7 -46 l0 -38 61 0 60 0 -3 43 -3 42 -50 3
      c-28 2 -54 0 -58 -4z m83 -39 c0 -10 -10 -15 -30 -15 -20 0 -30 5 -30 15 0 10
      10 15 30 15 20 0 30 -5 30 -15z"/>
      <path d="M787 614 c-4 -4 -7 -27 -7 -51 l0 -43 61 0 60 0 -3 48 -3 47 -50 3
      c-28 2 -54 0 -58 -4z m81 -46 c3 -14 -3 -18 -27 -18 -29 0 -41 17 -24 34 13
      13 48 1 51 -16z"/>
      <path d="M787 424 c-4 -4 -7 -27 -7 -51 l0 -43 61 0 60 0 -3 48 -3 47 -50 3
      c-28 2 -54 0 -58 -4z m81 -46 c3 -14 -3 -18 -27 -18 -29 0 -41 17 -24 34 13
      13 48 1 51 -16z"/>
      <path d="M787 234 c-4 -4 -7 -27 -7 -51 l0 -43 61 0 60 0 -3 48 -3 47 -50 3
      c-28 2 -54 0 -58 -4z m81 -46 c3 -14 -3 -18 -27 -18 -29 0 -41 17 -24 34 13
      13 48 1 51 -16z"/>
      <path d="M147 744 c-4 -4 -7 -29 -7 -56 l0 -48 51 0 50 0 -3 53 -3 52 -40 3
      c-23 2 -44 0 -48 -4z m63 -49 c0 -18 -5 -25 -20 -25 -20 0 -28 28 -13 43 15
      16 33 6 33 -18z"/>
      <path d="M307 744 c-4 -4 -7 -29 -7 -56 l0 -48 51 0 50 0 -3 53 -3 52 -40 3
      c-23 2 -44 0 -48 -4z m63 -49 c0 -18 -5 -25 -20 -25 -20 0 -28 28 -13 43 15
      16 33 6 33 -18z"/>
      <path d="M467 744 c-4 -4 -7 -29 -7 -56 l0 -48 51 0 50 0 -3 53 -3 52 -40 3
      c-23 2 -44 0 -48 -4z m63 -49 c0 -18 -5 -25 -20 -25 -20 0 -28 28 -13 43 15
      16 33 6 33 -18z"/>
      <path d="M147 564 c-4 -4 -7 -27 -7 -51 l0 -43 51 0 50 0 -3 48 -3 47 -40 3
      c-23 2 -44 0 -48 -4z m63 -44 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13
      7 20 20 20 13 0 20 -7 20 -20z"/>
      <path d="M307 564 c-4 -4 -7 -27 -7 -51 l0 -43 51 0 50 0 -3 48 -3 47 -40 3
      c-23 2 -44 0 -48 -4z m63 -44 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13
      7 20 20 20 13 0 20 -7 20 -20z"/>
      <path d="M467 564 c-4 -4 -7 -27 -7 -51 l0 -43 51 0 50 0 -3 48 -3 47 -40 3
      c-23 2 -44 0 -48 -4z m63 -44 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13
      7 20 20 20 13 0 20 -7 20 -20z"/>
      <path d="M147 394 c-4 -4 -7 -27 -7 -51 l0 -43 51 0 50 0 -3 48 -3 47 -40 3
      c-23 2 -44 0 -48 -4z m63 -44 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13
      7 20 20 20 13 0 20 -7 20 -20z"/>
      <path d="M307 394 c-4 -4 -7 -27 -7 -51 l0 -43 51 0 50 0 -3 48 -3 47 -40 3
      c-23 2 -44 0 -48 -4z m63 -44 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13
      7 20 20 20 13 0 20 -7 20 -20z"/>
      <path d="M467 394 c-4 -4 -7 -27 -7 -51 l0 -43 51 0 50 0 -3 48 -3 47 -40 3
      c-23 2 -44 0 -48 -4z m63 -44 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13
      7 20 20 20 13 0 20 -7 20 -20z"/>
      <path d="M147 224 c-4 -4 -7 -27 -7 -51 l0 -43 51 0 50 0 -3 48 -3 47 -40 3
      c-23 2 -44 0 -48 -4z m63 -44 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13
      7 20 20 20 13 0 20 -7 20 -20z"/>
      <path d="M467 224 c-4 -4 -7 -27 -7 -51 l0 -43 51 0 50 0 -3 48 -3 47 -40 3
      c-23 2 -44 0 -48 -4z m63 -44 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13
      7 20 20 20 13 0 20 -7 20 -20z"/>
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'group'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="119.000000pt" height="73.000000pt" viewBox="0 0 119.000000 73.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,73.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M194 666 c-69 -30 -101 -121 -66 -187 l19 -37 -33 -16 c-18 -8 -46
        -34 -61 -56 -24 -38 -27 -50 -27 -138 l-1 -96 50 -19 c36 -14 78 -20 152 -21
        98 -1 103 -2 103 -22 0 -32 88 -54 238 -61 166 -8 292 20 292 65 0 15 12 17
        93 17 57 1 114 7 150 18 l57 18 0 96 c0 84 -3 102 -24 138 -14 22 -40 49 -59
        60 l-34 18 19 43 c16 37 17 50 8 86 -29 104 -151 141 -229 69 -49 -45 -57
        -113 -23 -177 9 -17 5 -23 -29 -42 -23 -14 -48 -21 -59 -17 -18 6 -18 7 2 42
        27 45 28 110 2 154 -61 104 -203 107 -278 6 -29 -39 -28 -126 2 -166 l22 -31
        -23 -5 c-16 -4 -36 1 -59 18 -33 22 -35 25 -22 48 19 33 17 105 -3 139 -20 35
        -81 70 -119 70 -16 -1 -43 -7 -60 -14z m106 -31 c64 -33 80 -109 35 -163 -32
        -38 -31 -48 3 -57 15 -3 37 -13 49 -21 l23 -14 -21 -21 c-36 -36 -59 -100 -59
        -166 l0 -61 -41 -7 c-45 -8 -133 0 -191 17 l-38 11 0 90 0 89 39 39 c21 22 53
        42 70 45 32 7 42 28 18 37 -8 3 -22 22 -31 42 -22 45 -14 84 22 117 44 41 76
        47 122 23z m360 0 c37 -19 60 -62 60 -112 0 -39 -31 -103 -50 -103 -5 0 -10
        -7 -10 -15 0 -8 17 -19 42 -26 53 -14 103 -64 118 -117 6 -23 10 -75 8 -115
        l-3 -72 -40 -15 c-54 -20 -311 -19 -375 1 l-45 15 -3 79 c-5 129 35 198 128
        226 22 7 40 15 40 19 0 4 -11 17 -25 30 -61 58 -49 165 24 205 34 19 95 19
        131 0z m353 -25 c37 -41 38 -106 2 -140 -33 -31 -32 -47 5 -55 76 -17 110 -73
        110 -183 l0 -80 -42 -10 c-76 -19 -137 -24 -183 -18 l-45 7 0 52 c0 72 -16
        122 -51 162 l-30 34 23 15 c13 8 35 18 51 21 33 9 34 19 2 57 -45 53 -25 142
        39 169 37 15 89 2 119 -31z" stroke-width="18"   stroke="black"/>
        </g>
        </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'application'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="110.000000pt" height="91.000000pt" viewBox="0 0 110.000000 91.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,91.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M56 848 c-14 -19 -16 -75 -16 -404 0 -375 0 -381 21 -400 20 -18 43
        -19 511 -19 l490 0 19 24 c18 22 19 44 19 402 0 366 -1 380 -20 399 -19 19
        -33 20 -514 20 l-495 0 -15 -22z m1002 -20 c7 -7 12 -34 12 -60 l0 -48 -500 0
        -500 0 0 44 c0 83 -45 76 494 76 362 0 485 -3 494 -12z m12 -445 c0 -164 -4
        -304 -8 -311 -7 -10 -113 -12 -498 -10 l-489 3 -3 308 -2 307 500 0 500 0 0
        -297z" stroke-width="18"   stroke="black"/>
        <path d="M122 779 c2 -6 8 -10 13 -10 5 0 11 4 13 10 2 6 -4 11 -13 11 -9 0
        -15 -5 -13 -11z" stroke-width="18"   stroke="black"/>
        <path d="M182 779 c2 -6 8 -10 13 -10 5 0 11 4 13 10 2 6 -4 11 -13 11 -9 0
        -15 -5 -13 -11z" stroke-width="18"   stroke="black"/>
        <path d="M252 779 c2 -6 8 -10 13 -10 5 0 11 4 13 10 2 6 -4 11 -13 11 -9 0
        -15 -5 -13 -11z" stroke-width="18"   stroke="black"/>
        <path d="M172 533 c3 -16 18 -18 153 -18 135 0 150 2 153 18 3 16 -9 17 -153
        17 -144 0 -156 -1 -153 -17z" stroke-width="18"   stroke="black"/>
        <path d="M722 527 c-39 -41 -25 -97 28 -116 37 -12 72 -1 94 31 21 30 20 50
        -5 82 -27 35 -86 36 -117 3z m98 -27 c16 -30 -4 -60 -39 -60 -39 0 -57 23 -43
        55 15 32 66 35 82 5z"/>
        <path d="M173 448 c5 -18 299 -18 305 0 3 9 -32 12 -153 12 -121 0 -156 -3
        -152 -12z" stroke-width="18"   stroke="black" />
        <path d="M172 363 c3 -16 18 -18 153 -18 135 0 150 2 153 18 3 16 -9 17 -153
        17 -144 0 -156 -1 -153 -17z" stroke-width="18"   stroke="black" />
        <path d="M625 355 c-21 -20 -25 -34 -25 -80 0 -49 -3 -58 -20 -62 -12 -3 -19
        -11 -17 -17 6 -17 429 -15 435 2 2 7 -5 12 -17 12 -19 0 -21 6 -21 60 0 51 -4
        65 -25 85 -23 24 -29 25 -155 25 -126 0 -132 -1 -155 -25z m289 -24 c22 -25
        19 -116 -4 -116 -10 0 -16 13 -18 43 -2 28 -8 42 -18 42 -10 0 -14 -12 -14
        -45 l0 -45 -80 0 -80 0 0 45 c0 33 -4 45 -14 45 -10 0 -16 -14 -18 -42 -2 -31
        -8 -44 -20 -46 -15 -3 -18 5 -18 52 0 81 8 86 149 86 103 0 120 -2 135 -19z"/>
        <path d="M173 278 c5 -18 299 -18 305 0 3 9 -32 12 -153 12 -121 0 -156 -3
        -152 -12z" stroke-width="18"   stroke="black"/>
        <path d="M172 193 c3 -16 18 -18 153 -18 135 0 150 2 153 18 3 16 -9 17 -153
        17 -144 0 -156 -1 -153 -17z" stroke-width="18"   stroke="black"/>
        </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'listing'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="96.000000pt" height="96.000000pt" viewBox="0 0 96.000000 96.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M282 945 c-74 -21 -108 -41 -168 -97 -33 -31 -62 -71 -80 -111 -25
        -53 -29 -74 -29 -152 0 -76 4 -98 26 -145 39 -81 99 -144 177 -182 62 -31 74
        -33 167 -33 87 0 107 3 155 26 l55 26 136 -133 c148 -147 172 -159 217 -111
        41 43 31 61 -113 207 l-136 136 28 60 c24 51 28 72 28 149 0 78 -4 98 -29 153
        -74 161 -269 253 -434 207z m169 -29 c110 -25 189 -90 238 -196 38 -80 37
        -192 -2 -272 -59 -121 -163 -190 -297 -196 -301 -15 -469 335 -270 561 41 47
        100 82 170 101 69 19 92 19 161 2z m345 -692 c68 -63 126 -124 129 -135 8 -23
        -10 -49 -34 -49 -8 0 -73 57 -143 127 l-128 127 22 23 c12 13 24 23 26 23 3 0
        60 -52 128 -116z"  stroke-width="15" stroke="black"/>
        <path d="M313 740 c-39 -23 -67 -64 -59 -85 9 -24 22 -18 44 20 24 39 58 52
        105 38 39 -11 63 -49 53 -87 -4 -15 -24 -46 -46 -70 -39 -43 -64 -89 -53 -100
        14 -14 31 -4 43 23 6 16 25 42 42 57 82 79 74 172 -18 210 -45 19 -73 17 -111
        -6z"  stroke-width="15" stroke="black"/>
        <path d="M353 404 c-8 -21 13 -42 28 -27 13 13 5 43 -11 43 -6 0 -13 -7 -17
        -16z"  stroke-width="15" stroke="black"/>
        </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'dollar in box'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="105.000000pt" height="105.000000pt" viewBox="0 0 105.000000 105.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,105.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M401 1004 c-223 -60 -380 -262 -381 -489 0 -145 53 -268 160 -369 79
        -74 152 -112 261 -134 341 -71 666 250 596 589 -23 112 -61 183 -142 265 -105
        106 -220 154 -365 153 -41 0 -99 -7 -129 -15z m231 -25 c371 -78 510 -534 242
        -801 -266 -265 -714 -145 -809 217 -41 159 0 315 117 440 116 125 284 179 450
        144z" stroke-width="15" stroke="black"/>
        <path d="M406 921 c-241 -80 -364 -358 -258 -584 83 -178 270 -280 453 -249
        191 33 331 177 361 370 28 179 -75 363 -249 445 -87 40 -217 48 -307 18z m298
        -49 c160 -75 255 -252 226 -421 -37 -215 -245 -369 -450 -333 -137 25 -237 98
        -296 218 -93 187 -33 399 146 514 106 68 257 77 374 22z" stroke-width="15" stroke="black"/>
        <path d="M520 737 c0 -31 -4 -35 -40 -46 -46 -14 -70 -43 -70 -86 0 -49 24
        -72 98 -95 93 -29 112 -43 112 -85 0 -18 -7 -40 -15 -48 -34 -35 -118 -32
        -151 4 -20 22 -44 25 -44 5 0 -18 47 -52 83 -61 21 -6 27 -14 29 -41 4 -45 22
        -44 26 0 3 29 8 37 36 46 48 15 71 45 71 90 0 53 -32 84 -114 111 -76 25 -101
        43 -101 74 0 37 36 60 92 60 44 0 53 -4 77 -32 26 -31 51 -43 51 -24 0 18 -45
        64 -77 77 -28 12 -33 19 -33 49 0 24 -5 35 -15 35 -10 0 -15 -10 -15 -33z" stroke-width="15" stroke="black"/>
        </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'couple'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="137.000000pt" height="84.000000pt" viewBox="0 0 137.000000 64.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M775 603 c-11 -3 -28 -12 -37 -20 -15 -13 -19 -13 -40 1 -47 33 -119
        13 -147 -41 -15 -30 -14 -89 3 -121 32 -60 144 -147 179 -138 29 7 134 101
        152 137 34 64 9 150 -50 175 -19 8 -36 13 -37 13 -2 -1 -12 -4 -23 -6z m50
        -33 c37 -14 59 -71 45 -115 -11 -33 -86 -111 -129 -134 -18 -10 -27 -9 -47 4
        -51 33 -107 91 -121 123 -36 87 57 163 123 101 l23 -22 31 27 c35 29 38 30 75
        16z"  stroke-width="15" stroke="black"/>
        <path d="M264 536 c-43 -19 -64 -53 -64 -104 0 -35 6 -49 29 -73 65 -65 171
        -20 171 73 0 52 -21 85 -66 104 -39 16 -32 16 -70 0z m83 -48 c33 -30 31 -80
        -3 -107 -15 -12 -34 -21 -44 -21 -10 0 -29 9 -44 21 -33 26 -35 73 -4 106 27
        29 65 29 95 1z"  stroke-width="15" stroke="black"/>
        <path d="M1084 536 c-43 -19 -64 -53 -64 -104 0 -63 40 -102 105 -102 65 0
        105 39 105 102 0 52 -21 85 -66 104 -40 17 -41 17 -80 0z m91 -51 c14 -13 25
        -36 25 -50 0 -33 -42 -75 -75 -75 -33 0 -75 42 -75 75 0 33 42 75 75 75 14 0
        37 -11 50 -25z" stroke-width="15" stroke="black"/>
        <path d="M141 300 c-68 -16 -100 -76 -101 -185 0 -27 3 -60 6 -72 l6 -23 249
        0 249 0 0 105 c0 100 -1 106 -27 135 -17 19 -44 35 -68 40 -48 11 -266 11
        -314 0z m348 -56 c30 -25 31 -28 31 -110 l0 -84 -40 0 -40 0 0 56 c0 47 -3 55
        -17 52 -14 -2 -19 -15 -21 -56 l-3 -52 -99 0 -99 0 -3 52 c-2 41 -7 54 -20 56
        -15 3 -18 -5 -18 -52 l0 -56 -40 0 -40 0 0 84 c0 82 1 85 31 110 30 26 33 26
        189 26 156 0 159 0 189 -26z" stroke-width="15" stroke="black"/>
        <path d="M971 300 c-68 -16 -100 -76 -101 -185 0 -27 3 -60 6 -72 l6 -23 244
        0 244 0 0 105 c0 100 -1 106 -27 135 -17 19 -44 35 -68 40 -48 11 -256 11
        -304 0z m322 -42 c39 -20 46 -40 47 -125 l0 -83 -40 0 -40 0 0 55 c0 42 -3 55
        -15 55 -12 0 -15 -13 -15 -55 l0 -55 -105 0 -105 0 0 55 c0 42 -3 55 -15 55
        -12 0 -15 -13 -15 -55 l0 -55 -40 0 -40 0 0 83 c1 129 12 136 213 137 94 0
        156 -4 170 -12z" stroke-width="15" stroke="black"/>
        </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'truck'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="110.000000pt" height="87.000000pt" viewBox="0 0 110.000000 87.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,87.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M47 863 c-4 -3 -7 -164 -7 -358 0 -260 3 -354 12 -363 7 -7 27 -12
      45 -12 24 0 33 -5 33 -16 0 -9 15 -31 34 -50 29 -29 41 -34 79 -34 51 0 88 24
      107 70 l12 30 194 0 194 0 10 -25 c36 -95 165 -102 211 -13 15 30 25 38 47 38
      16 0 37 6 48 14 17 13 19 29 22 151 3 133 3 140 -33 258 -52 172 -45 167 -226
      167 l-148 0 -3 73 -3 72 -311 3 c-171 1 -313 -1 -317 -5z m603 -278 l0 -255
      -295 0 -295 0 0 248 c0 137 3 252 7 255 3 4 136 7 295 7 l288 0 0 -255z m328
      93 c5 -7 24 -58 42 -113 28 -86 33 -119 37 -231 6 -148 -1 -174 -45 -174 -21
      0 -30 7 -39 30 -13 33 -66 70 -103 70 -37 0 -90 -37 -103 -70 -10 -26 -17 -30
      -49 -30 l-38 0 0 258 c0 142 3 262 7 265 13 13 280 8 291 -5z m-328 -453 l0
      -65 -145 0 c-130 0 -146 2 -152 18 -11 32 -56 72 -88 78 -48 9 -101 -18 -122
      -60 -13 -29 -22 -36 -45 -36 -28 0 -28 0 -28 65 l0 65 290 0 290 0 0 -65z
      m-349 -21 c37 -34 32 -99 -10 -131 -27 -21 -79 -15 -106 12 -76 75 37 191 116
      119z m608 11 c33 -16 41 -33 41 -80 0 -66 -93 -101 -137 -52 -29 31 -34 52
      -22 87 11 29 49 59 77 60 7 0 26 -7 41 -15z"/>
      <path d="M747 633 c-4 -3 -7 -39 -7 -80 l0 -73 113 0 c63 0 116 3 119 6 10 9
      -33 128 -50 142 -17 13 -163 17 -175 5z m177 -70 c9 -26 16 -48 16 -50 0 -2
      -38 -3 -85 -3 l-85 0 0 50 0 50 69 0 69 0 16 -47z"/>
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black"  v-if="data.fields.iconCode == 'wheelchair'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="73.000000pt" height="105.000000pt" viewBox="0 0 73.000000 105.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,105.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M386 991 c-39 -26 -55 -57 -56 -109 0 -34 6 -49 33 -77 104 -114 273
        23 189 153 -33 51 -114 67 -166 33z m125 -39 c44 -40 44 -95 -1 -135 -27 -24
        -39 -28 -69 -23 -79 12 -108 101 -52 157 39 38 80 39 122 1z"/>
        <path d="M270 746 c-35 -24 -90 -109 -90 -140 0 -21 -9 -20 -40 4 -27 21 -50
        26 -50 11 0 -5 17 -22 38 -38 35 -26 37 -31 32 -70 -4 -34 -13 -49 -49 -79
        -56 -49 -81 -102 -81 -179 0 -148 137 -253 280 -215 62 17 135 90 152 153 7
        26 18 47 24 47 7 0 28 -29 48 -64 55 -98 82 -126 120 -126 42 0 70 30 69 74
        -1 19 -28 89 -61 159 l-60 126 40 -2 c29 -1 44 4 54 18 36 49 -2 94 -103 124
        l-73 21 -51 80 c-28 44 -62 89 -76 100 -34 27 -81 25 -123 -4z m111 -27 c11
        -11 43 -55 70 -97 l50 -77 81 -25 c87 -27 113 -49 88 -74 -13 -12 -29 -12
        -120 0 -110 14 -131 26 -146 82 -3 12 -12 22 -20 22 -10 0 -14 -14 -14 -50 l0
        -51 -32 17 c-20 11 -56 17 -92 17 l-58 0 5 48 c13 104 84 209 142 209 14 0 34
        -9 46 -21z m-86 -270 c182 -50 197 -301 23 -374 -49 -20 -94 -19 -143 4 -78
        36 -115 95 -115 182 0 88 57 164 140 187 47 14 49 14 95 1z m120 1 c3 -5 1
        -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m116 -55 l46 -6
        55 -117 c31 -64 59 -125 62 -135 15 -46 -45 -77 -75 -41 -8 10 -34 51 -59 93
        -32 54 -52 77 -67 79 -16 2 -23 10 -23 26 0 13 -11 44 -25 70 l-25 47 33 -5
        c17 -3 53 -8 78 -11z"/>
        </g>
        </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'covid19'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="105.000000pt" height="100.000000pt" viewBox="0 0 105.000000 100.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M460 975 c0 -10 10 -15 30 -15 27 0 30 -3 30 -34 0 -28 -6 -38 -36
      -55 -21 -13 -52 -21 -79 -21 -58 0 -71 -6 -96 -47 l-22 -34 -33 32 -34 33 20
      21 c23 25 25 35 7 35 -21 0 -111 -97 -97 -105 6 -4 20 1 31 11 19 17 21 17 52
      -15 30 -30 31 -33 13 -43 -42 -24 -56 -48 -56 -94 0 -28 -8 -59 -22 -84 -19
      -34 -28 -40 -55 -40 -28 0 -33 4 -33 24 0 29 -19 44 -31 25 -11 -18 -11 -110
      0 -128 12 -19 31 -4 31 25 0 20 5 24 33 24 27 0 36 -6 55 -40 14 -25 22 -56
      22 -84 0 -46 14 -70 56 -94 18 -10 17 -13 -13 -43 -31 -32 -33 -32 -52 -15
      -11 10 -25 15 -31 11 -14 -8 76 -105 97 -105 18 0 16 10 -7 35 l-20 21 34 33
      33 32 22 -34 c25 -41 38 -47 96 -47 27 0 58 -8 79 -21 30 -17 36 -27 36 -55 0
      -31 -3 -34 -30 -34 -20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15
      0 10 -10 15 -30 15 -27 0 -30 3 -30 34 0 28 6 38 36 55 21 13 52 21 79 21 58
      0 71 6 96 47 l22 34 33 -32 34 -33 -20 -21 c-23 -25 -25 -35 -7 -35 21 0 111
      97 97 105 -6 4 -20 -1 -31 -11 -19 -17 -21 -17 -52 15 -30 30 -31 33 -13 43
      42 24 56 48 56 94 0 28 8 59 23 84 18 34 27 40 55 40 27 0 32 -4 32 -24 0 -29
      19 -44 31 -25 5 8 9 37 9 64 0 28 -4 56 -9 64 -12 19 -31 4 -31 -25 0 -20 -5
      -24 -32 -24 -28 0 -37 6 -55 40 -15 25 -23 56 -23 84 0 46 -14 70 -56 94 -18
      10 -17 13 13 43 31 32 33 32 52 15 11 -10 25 -15 31 -11 14 8 -76 105 -97 105
      -18 0 -16 -10 7 -35 l20 -21 -34 -33 -33 -32 -22 34 c-25 41 -38 47 -96 47
      -27 0 -58 8 -79 21 -30 17 -36 27 -36 55 0 31 3 34 30 34 20 0 30 5 30 15 0
      12 -15 15 -75 15 -60 0 -75 -3 -75 -15z m117 -132 c15 -10 52 -20 82 -23 51
      -5 57 -8 82 -44 14 -21 44 -51 65 -65 36 -25 39 -31 44 -81 3 -30 13 -66 23
      -80 22 -31 22 -59 0 -90 -10 -14 -20 -50 -23 -80 -5 -50 -8 -56 -44 -81 -21
      -14 -51 -44 -65 -65 -25 -36 -31 -39 -82 -44 -30 -3 -67 -13 -82 -23 -33 -22
      -51 -22 -84 1 -15 9 -52 19 -82 22 -51 5 -57 8 -82 44 -14 21 -44 51 -65 65
      -36 25 -39 31 -44 81 -3 30 -13 66 -23 80 -22 31 -22 59 0 90 10 14 20 50 23
      80 5 50 8 56 44 81 21 14 51 44 65 65 25 36 31 39 82 44 30 3 66 13 80 22 31
      22 53 22 86 1z"/>
      <path d="M497 692 c-35 -38 -9 -102 40 -102 47 0 71 71 35 103 -24 22 -55 21
      -75 -1z m58 -42 c0 -16 -6 -26 -18 -28 -19 -4 -32 20 -23 44 9 25 41 13 41
      -16z"/>
      <path d="M347 542 c-35 -38 -9 -102 40 -102 47 0 71 71 35 103 -24 22 -55 21
      -75 -1z m58 -42 c0 -16 -6 -26 -18 -28 -19 -4 -32 20 -23 44 9 25 41 13 41
      -16z"/>
      <path d="M647 542 c-35 -38 -9 -102 40 -102 47 0 71 71 35 103 -24 22 -55 21
      -75 -1z m58 -42 c0 -29 -32 -41 -41 -16 -9 24 4 48 23 44 12 -2 18 -12 18 -28z"/>
      <path d="M497 392 c-35 -38 -9 -102 40 -102 47 0 71 71 35 103 -24 22 -55 21
      -75 -1z m58 -42 c0 -16 -6 -26 -18 -28 -19 -4 -32 20 -23 44 9 25 41 13 41
      -16z"/>
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'interview waiver'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="91.000000pt" height="96.000000pt" viewBox="0 0 91.000000 96.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M415 920 l-39 -40 -113 0 -113 0 0 -98 0 -99 -60 -57 -60 -58 2 -277
      3 -276 428 -3 427 -2 0 284 0 285 -55 47 -55 48 0 103 0 103 -111 0 -110 0
      -48 40 c-26 22 -49 40 -52 40 -3 0 -23 -18 -44 -40z m70 -20 c18 -20 17 -20
      -25 -20 -42 0 -43 0 -25 20 10 11 21 20 25 20 4 0 15 -9 25 -20z m265 -224 l0
      -174 -139 -91 c-77 -50 -144 -91 -149 -91 -5 0 -70 40 -145 90 l-137 89 0 176
      0 175 285 0 285 0 0 -174z m-600 -96 c0 -27 -3 -50 -8 -50 -6 0 -43 22 -61 37
      -6 4 51 63 61 63 4 0 8 -22 8 -50z m699 -11 c1 -5 -15 -14 -61 -37 -5 -2 -8
      20 -8 48 l0 52 34 -29 c19 -15 35 -31 35 -34z m-603 -150 c93 -61 173 -114
      177 -119 7 -6 -312 -222 -350 -237 -11 -4 -13 38 -13 231 0 130 4 236 9 236 4
      0 84 -50 177 -111z m614 -125 c0 -130 -4 -234 -9 -232 -4 2 -87 55 -184 118
      l-176 115 177 117 c97 64 180 117 185 118 4 0 7 -106 7 -236z m-210 -139 l174
      -115 -359 0 c-197 0 -356 3 -353 6 21 20 336 222 348 223 8 0 94 -51 190 -114z"/>
      <path d="M267 764 c-18 -18 15 -24 129 -24 104 0 124 2 124 15 0 13 -20 15
      -123 15 -68 0 -127 -3 -130 -6z"/>
      <path d="M267 684 c-19 -19 22 -24 199 -24 166 0 194 2 194 15 0 13 -28 15
      -193 15 -107 0 -197 -3 -200 -6z"/>
      <path d="M267 604 c-19 -19 22 -24 199 -24 166 0 194 2 194 15 0 13 -28 15
      -193 15 -107 0 -197 -3 -200 -6z"/>
      <path d="M357 514 c-18 -19 18 -24 154 -24 126 0 149 2 149 15 0 13 -23 15
      -148 15 -82 0 -152 -3 -155 -6z"/>
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'faqds260'">
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="96.000000pt" height="100.000000pt" viewBox="0 0 96.000000 100.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M22 967 c-22 -23 -22 -25 -22 -470 0 -434 1 -448 20 -467 19 -19 33
        -20 378 -20 335 0 360 1 375 18 23 26 25 222 2 222 -11 0 -15 -20 -17 -102
        l-3 -103 -349 -3 c-249 -2 -353 1 -362 9 -19 16 -21 878 -2 897 18 18 691 17
        706 -1 6 -7 13 -58 14 -112 2 -68 7 -100 16 -103 9 -3 12 23 12 107 0 165 36
        151 -393 151 l-354 0 -21 -23z"/>
        <path d="M127 834 c-19 -20 29 -24 274 -24 212 0 270 3 267 13 -4 9 -68 13
        -270 15 -145 1 -267 -1 -271 -4z"/>
        <path d="M590 730 c-14 -4 -123 -8 -242 -9 -147 -1 -219 -5 -224 -12 -14 -23
        26 -29 200 -29 170 0 178 -1 164 -17 -9 -10 -23 -33 -32 -50 l-17 -33 -160 0
        c-124 0 -160 -3 -157 -12 4 -10 47 -14 161 -16 l157 -3 0 -27 c0 -15 3 -37 6
        -49 l6 -23 -167 0 c-129 0 -166 -3 -163 -12 4 -10 49 -14 173 -16 l168 -2 43
        -39 c62 -58 125 -72 199 -46 l39 14 72 -69 c74 -72 100 -83 128 -54 30 29 18
        57 -53 128 l-69 69 14 40 c8 22 14 51 14 65 0 132 -140 241 -260 202z m147
        -51 c93 -58 106 -192 26 -272 -82 -83 -212 -64 -270 39 -39 68 -23 165 35 217
        54 49 145 56 209 16z m137 -350 c53 -57 63 -78 40 -86 -15 -5 -137 124 -130
        136 14 22 35 10 90 -50z"/>
        <path d="M127 314 c-19 -19 22 -24 204 -24 156 0 200 3 197 13 -4 9 -54 13
        -199 15 -108 1 -198 -1 -202 -4z"/>
        <path d="M127 184 c-19 -20 29 -24 274 -24 212 0 270 3 267 13 -4 9 -68 13
        -270 15 -145 1 -267 -1 -271 -4z"/>
        </g>
        </svg>

    </span> 
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'immigrantvisa' ">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="142.000000pt" height="110.000000pt" viewBox="0 0 142.000000 110.000000"
      preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M166 1058 c-12 -17 -16 -50 -16 -138 0 -132 9 -155 65 -166 24 -4 41
      -17 59 -45 15 -21 31 -39 36 -39 5 0 21 18 36 39 18 28 35 41 59 45 56 11 65
      34 65 166 0 163 3 160 -160 160 -122 0 -130 -1 -144 -22z m264 -8 c11 -7 16
      -35 18 -119 4 -129 -3 -151 -53 -151 -30 0 -38 -6 -57 -40 -13 -22 -25 -40
      -28 -40 -3 0 -15 18 -28 40 -19 34 -27 40 -57 40 -50 0 -57 22 -53 151 2 84 7
      112 18 119 8 5 62 10 120 10 58 0 112 -5 120 -10z" stroke="black" stroke-width="18"/>
      <path d="M239 981 c-74 -74 10 -191 105 -146 61 29 74 99 27 146 -41 40 -91
      40 -132 0z m111 -11 c28 -28 27 -84 -2 -104 -49 -35 -108 -7 -108 50 0 41 29
      74 65 74 14 0 34 -9 45 -20z" stroke="black" stroke-width="18"/>
      <path d="M566 1058 c-12 -17 -16 -50 -16 -138 0 -132 9 -155 65 -166 24 -4 41
      -17 59 -45 15 -21 31 -39 36 -39 5 0 21 18 36 39 18 28 35 41 59 45 56 11 65
      34 65 166 0 163 3 160 -160 160 -122 0 -130 -1 -144 -22z m264 -8 c11 -7 16
      -35 18 -119 4 -129 -3 -151 -53 -151 -30 0 -38 -6 -57 -40 -13 -22 -25 -40
      -28 -40 -3 0 -15 18 -28 40 -19 34 -27 40 -57 40 -50 0 -57 22 -53 151 2 84 7
      112 18 119 8 5 62 10 120 10 58 0 112 -5 120 -10z" stroke="black" stroke-width="18"/>
      <path d="M678 990 c-12 -21 -25 -30 -43 -30 -35 0 -44 -28 -16 -51 16 -13 22
      -27 20 -46 -5 -45 7 -56 42 -38 26 14 32 14 58 1 35 -19 52 -5 44 35 -4 22 0
      33 17 47 29 24 21 52 -15 52 -18 0 -31 9 -43 30 -9 16 -24 30 -32 30 -8 0 -23
      -14 -32 -30z m50 -25 c8 -18 19 -25 39 -25 l26 0 -22 -24 c-16 -17 -20 -30
      -15 -50 6 -26 5 -26 -20 -15 -20 9 -32 9 -52 0 -25 -11 -25 -10 -19 17 4 21 1
      33 -16 48 l-21 19 28 5 c17 3 33 14 39 28 13 28 19 28 33 -3z" stroke="black" stroke-width="18"/>
      <path d="M966 1058 c-12 -17 -16 -50 -16 -138 0 -132 9 -155 65 -166 24 -4 41
      -17 59 -45 15 -21 31 -39 36 -39 5 0 21 18 36 39 18 28 35 41 59 45 56 11 65
      34 65 166 0 163 3 160 -160 160 -122 0 -130 -1 -144 -22z m264 -8 c11 -7 16
      -35 18 -119 4 -129 -3 -151 -53 -151 -30 0 -38 -6 -57 -40 -13 -22 -25 -40
      -28 -40 -3 0 -15 18 -28 40 -19 34 -27 40 -57 40 -50 0 -57 22 -53 151 2 84 7
      112 18 119 8 5 62 10 120 10 58 0 112 -5 120 -10z" stroke="black" stroke-width="18"/>
      <path d="M1036 984 c-3 -9 -6 -42 -6 -74 0 -69 11 -80 85 -80 74 0 85 11 85
      80 0 89 -1 90 -85 90 -57 0 -74 -3 -79 -16z m139 -64 l0 -55 -60 0 -60 0 -3
      44 c-5 68 0 72 65 69 l58 -3 0 -55z" stroke="black" stroke-width="18"/>
      <path d="M248 624 c-87 -46 -69 -179 27 -213 35 -12 45 -11 77 2 42 18 78 68
      78 110 0 89 -101 146 -182 101z m120 -34 c49 -46 39 -113 -21 -145 l-37 -20
      -37 20 c-60 32 -70 99 -21 145 29 27 87 27 116 0z" stroke="black" stroke-width="18"/>
      <path d="M648 624 c-87 -46 -69 -179 27 -213 35 -12 45 -11 77 2 42 18 78 68
      78 110 0 89 -101 146 -182 101z m120 -34 c49 -46 39 -113 -21 -145 l-37 -20
      -37 20 c-60 32 -70 99 -21 145 29 27 87 27 116 0z" stroke="black" stroke-width="18"/>
      <path d="M1048 624 c-87 -46 -69 -179 27 -213 35 -12 45 -11 77 2 42 18 78 68
      78 110 0 89 -101 146 -182 101z m120 -34 c49 -46 39 -113 -21 -145 l-37 -20
      -37 20 c-60 32 -70 99 -21 145 29 27 87 27 116 0z" stroke="black" stroke-width="18"/>
      <path d="M90 351 c-55 -29 -70 -70 -70 -188 0 -91 2 -103 19 -113 27 -14 1315
      -14 1342 0 17 10 19 22 19 113 0 118 -15 159 -70 188 -31 17 -75 18 -620 18
      -545 0 -589 -1 -620 -18z m358 -42 c-20 -26 -23 -45 -26 -135 l-4 -105 -116 3
      -117 3 -3 63 c-2 34 -7 62 -12 62 -5 0 -10 -28 -12 -62 l-3 -63 -52 -3 -53 -3
      0 101 0 102 34 34 34 34 176 0 177 0 -23 -31z m489 -2 c27 -26 28 -31 28 -130
      l0 -102 -52 -3 -53 -3 0 65 c0 52 -3 66 -15 66 -12 0 -15 -14 -15 -65 l0 -65
      -120 0 -120 0 0 65 c0 51 -3 65 -15 65 -12 0 -15 -14 -15 -65 l0 -65 -56 0
      -56 0 4 104 c3 110 14 136 63 157 11 5 104 7 207 6 l188 -2 27 -28z m399 -1
      l34 -34 0 -102 0 -101 -52 3 -53 3 -3 63 c-2 34 -7 62 -12 62 -5 0 -10 -28
      -12 -62 l-3 -63 -117 -3 -116 -3 -4 105 c-3 90 -6 109 -26 135 l-23 31 177 0
      176 0 34 -34z" stroke="black" stroke-width="18"/>
      </g>
      </svg>
    </span>  

    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'faqds160'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="123.000000pt" height="100.000000pt" viewBox="0 0 123.000000 100.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M39 951 l-29 -29 0 -347 0 -347 29 -29 29 -29 231 0 231 0 0 -50 0
      -49 -57 -3 c-44 -2 -58 -7 -58 -18 0 -13 29 -15 189 -18 124 -2 193 1 200 8
      17 17 -12 30 -66 30 l-48 0 0 50 0 50 220 0 c148 0 227 4 245 12 53 24 55 39
      55 393 0 347 -3 370 -49 395 -13 6 -207 10 -556 10 l-537 0 -29 -29z m1107 -9
      c31 -20 34 -55 34 -341 l0 -291 -570 0 -570 0 0 300 c0 287 1 301 20 320 19
      19 33 20 548 20 290 0 532 -4 538 -8z m34 -677 c0 -9 -11 -27 -25 -40 l-24
      -25 -522 0 -523 0 -23 22 c-13 12 -23 30 -23 40 0 17 25 18 570 18 507 0 570
      -2 570 -15z m-520 -145 l0 -50 -50 0 -50 0 0 50 0 50 50 0 50 0 0 -50z"/>
      <path d="M475 866 c-17 -7 -44 -29 -62 -49 -133 -151 3 -373 198 -323 l54 14
      71 -69 c40 -38 77 -69 83 -69 17 0 51 38 51 56 0 9 -31 48 -68 88 l-68 71 14
      43 c29 87 -15 189 -97 232 -47 23 -130 26 -176 6z m167 -38 c54 -31 82 -80 82
      -144 0 -96 -69 -164 -169 -164 -57 0 -96 19 -131 65 -65 86 -26 219 76 258 36
      13 104 6 142 -15z m192 -410 c-11 -18 -32 -6 -87 50 -45 46 -55 60 -45 70 10
      10 25 -1 75 -50 34 -34 60 -65 57 -70z"/>
      <path d="M580 695 l-44 -45 -27 26 c-41 39 -49 10 -8 -32 l33 -34 58 57 c32
      32 58 61 58 65 0 20 -30 4 -70 -37z"/>
      </g>
      </svg>
    </span>  
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'Boarding'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="123.000000pt" height="68.000000pt" viewBox="0 0 123.000000 68.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M61 644 l-31 -26 0 -263 0 -264 24 -28 24 -28 526 -3 525 -3 33 30
      33 29 3 224 c4 262 0 302 -35 334 l-26 24 -523 0 -522 0 -31 -26z m1081 -21
      c10 -9 18 -29 18 -45 l0 -28 -550 0 -550 0 0 29 c0 62 -9 61 554 61 460 0 511
      -2 528 -17z m-354 -330 l-3 -228 -348 0 c-334 0 -349 1 -363 19 -11 16 -14 64
      -14 228 l0 208 365 0 365 0 -2 -227z m372 13 c0 -266 16 -246 -192 -246 l-148
      0 0 230 0 230 170 0 170 0 0 -214z"/>
      <path d="M130 385 c0 -13 14 -15 93 -13 53 2 92 7 92 13 0 6 -39 11 -92 13
      -79 2 -93 0 -93 -13z"/>
      <path d="M390 385 c0 -13 20 -15 150 -13 200 4 200 22 0 26 -130 2 -150 0
      -150 -13z"/>
      <path d="M130 285 c0 -13 9 -16 43 -13 23 2 42 8 42 13 0 6 -19 11 -42 13 -34
      3 -43 0 -43 -13z"/>
      <path d="M270 285 c0 -13 13 -15 85 -13 111 4 111 22 0 26 -72 2 -85 0 -85
      -13z"/>
      <path d="M510 285 c0 -13 14 -15 93 -13 53 2 92 7 92 13 0 6 -39 11 -92 13
      -79 2 -93 0 -93 -13z"/>
      <path d="M130 185 c0 -13 25 -15 198 -13 265 4 265 22 0 26 -173 2 -198 0
      -198 -13z"/>
      <path d="M580 185 c0 -13 10 -15 55 -13 30 2 55 8 55 13 0 6 -25 11 -55 13
      -45 2 -55 0 -55 -13z"/>
      <path d="M970 416 c0 -44 0 -44 -51 -62 -47 -17 -69 -37 -57 -50 3 -3 28 4 57
      15 l51 21 0 -74 c0 -70 -1 -74 -25 -80 -14 -4 -25 -14 -25 -22 0 -12 6 -15 25
      -10 18 5 25 2 25 -8 0 -24 21 -30 27 -7 4 16 11 19 29 15 18 -5 24 -2 24 10 0
      8 -11 18 -25 22 -24 6 -25 10 -25 80 0 41 2 74 4 74 2 0 25 -9 51 -20 49 -21
      74 -18 55 5 -6 7 -33 21 -61 31 -48 18 -49 18 -49 61 0 32 -4 43 -15 43 -11 0
      -15 -12 -15 -44z"/>
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'treatyinvestorsvisa'">
      <svg width="24" height="24" viewBox="0 0 512 512" :class="homeonly" aria-hidden="true" role="presentation" focusable="false">
        <path d="M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"></path>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'academicglobe'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="91.000000pt" height="105.000000pt" viewBox="0 0 91.000000 105.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,105.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M225 944 c-115 -52 -212 -97 -215 -101 -3 -3 5 -12 18 -20 20 -14 22
      -24 22 -92 0 -64 -3 -79 -20 -94 -22 -18 -27 -52 -9 -62 5 -4 8 -20 5 -36 -3
      -16 -9 -43 -12 -59 l-6 -30 50 0 50 0 -1 90 c0 63 -4 94 -14 101 -8 8 -13 35
      -13 80 0 38 2 69 4 69 2 0 25 -9 49 -19 l45 -20 4 -83 c2 -53 -1 -88 -8 -98
      -44 -57 -59 -106 -59 -195 0 -110 21 -162 92 -233 75 -74 130 -97 238 -97 108
      0 163 23 238 97 71 71 92 123 92 233 0 89 -15 138 -59 195 -7 9 -10 45 -8 97
      l4 83 84 39 c46 22 84 44 84 49 0 8 -428 203 -440 201 -3 0 -99 -43 -215 -95z
      m471 -49 c60 -27 113 -51 117 -55 7 -6 -349 -170 -368 -170 -15 0 -375 163
      -370 168 2 3 87 42 187 87 l183 82 71 -32 c39 -18 120 -54 180 -80z m-390
      -201 c151 -69 126 -68 249 -13 60 27 112 49 117 49 4 0 8 -25 8 -55 0 -52 -2
      -56 -37 -79 -118 -78 -278 -78 -395 0 -36 23 -38 27 -38 79 0 30 4 55 9 55 5
      0 44 -16 87 -36z m-226 -88 c0 -8 -5 -18 -11 -22 -14 -8 -33 11 -25 25 10 16
      36 13 36 -3z m171 -52 c27 -14 30 -19 25 -47 -3 -18 -8 -51 -12 -74 l-7 -43
      -59 0 -60 0 7 37 c9 49 56 143 72 143 2 0 18 -7 34 -16z m460 -39 c15 -28 30
      -67 33 -87 l7 -38 -59 0 -59 0 -12 72 c-12 70 -11 73 11 90 34 26 50 19 79
      -37z m-638 -2 c5 -25 3 -33 -8 -33 -16 0 -20 26 -9 55 8 20 10 18 17 -22z
      m340 -9 c13 -4 17 -16 17 -60 l0 -54 -71 0 -71 0 6 28 c2 15 7 44 11 65 l6 39
      42 -7 c23 -4 50 -9 60 -11z m171 -11 c2 -16 7 -45 11 -65 l6 -38 -71 0 -70 0
      0 55 c0 59 -4 54 65 68 45 10 53 7 59 -20z m-314 -210 c12 -75 12 -77 -11 -94
      -13 -10 -27 -19 -31 -19 -15 0 -60 71 -74 116 -22 73 -21 74 45 74 l58 0 13
      -77z m158 20 c-3 -57 -3 -58 -38 -64 -19 -3 -45 -9 -56 -13 -20 -6 -23 -2 -33
      57 -6 35 -11 67 -11 70 0 4 32 7 70 7 l71 0 -3 -57z m172 50 c0 -3 -5 -35 -11
      -70 -10 -59 -13 -63 -33 -57 -11 4 -37 10 -56 13 -35 6 -35 7 -38 64 l-3 57
      71 0 c38 0 70 -3 70 -7z m150 -6 c0 -50 -64 -178 -88 -177 -4 0 -18 9 -31 19
      -23 17 -23 19 -11 94 l13 77 58 0 c43 0 59 -4 59 -13z m-320 -207 c0 -64 -2
      -70 -17 -61 -31 16 -83 83 -83 106 0 9 42 24 73 24 27 1 27 1 27 -69z m122 52
      c17 -17 -32 -90 -74 -113 -16 -9 -18 -3 -18 62 l0 72 41 -6 c23 -3 46 -10 51
      -15z m-232 -62 c18 -36 19 -39 3 -33 -10 3 -31 15 -47 26 -27 19 -28 21 -10
      34 27 19 32 17 54 -27z m304 27 c18 -13 17 -15 -10 -34 -16 -11 -37 -23 -47
      -26 -16 -6 -15 -3 3 33 22 44 27 46 54 27z"/>
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'children'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="105.000000pt" height="105.000000pt" viewBox="0 0 105.000000 105.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,105.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M389 991 c-88 -28 -154 -69 -218 -135 -292 -305 -110 -798 314 -851
      79 -10 180 11 271 55 193 94 306 305 276 515 -29 200 -177 370 -367 420 -79
      20 -206 19 -276 -4z m272 -27 c260 -76 406 -356 319 -610 -74 -213 -289 -345
      -514 -314 -186 26 -353 179 -395 361 -56 243 96 497 339 565 64 18 187 17 251
      -2z"/>
      <path d="M480 830 c-40 -40 -16 -112 42 -126 22 -5 33 0 58 24 35 36 38 60 9
      96 -26 33 -79 36 -109 6z m90 -29 c15 -29 13 -39 -14 -56 -31 -21 -66 -5 -66
      28 0 46 59 66 80 28z"/>
      <path d="M232 698 c-7 -7 -12 -24 -12 -40 0 -38 32 -57 135 -76 l85 -16 0 -52
      c0 -64 -24 -205 -45 -264 -19 -54 -13 -87 20 -102 41 -19 69 9 90 89 25 93 31
      103 39 60 17 -91 37 -138 63 -148 19 -7 32 -6 49 6 29 19 30 34 4 127 -18 67
      -40 213 -40 263 0 18 10 23 68 33 110 19 142 31 154 57 9 19 7 30 -6 50 -19
      29 -43 31 -131 10 -78 -19 -260 -19 -350 0 -85 18 -107 19 -123 3z m118 -34
      c101 -21 268 -20 370 2 61 13 84 14 93 5 21 -21 -16 -41 -109 -57 -49 -9 -95
      -18 -103 -20 -24 -7 -2 -206 40 -357 12 -42 11 -49 -1 -57 -10 -6 -19 -5 -27
      3 -15 15 -48 140 -58 220 -7 52 -19 77 -31 64 -3 -3 -9 -36 -15 -73 -12 -91
      -48 -212 -65 -218 -30 -11 -32 19 -8 109 16 57 27 131 31 203 l6 112 -27 0
      c-38 0 -179 30 -190 40 -10 10 -1 40 11 40 4 0 42 -7 83 -16z"/>
      </g>
      </svg>
    </span> -->
    <!-- pooja, 11-apr-23, japan faq -->
    <!-- <span class="svg-lg text-black" v-if="data.fields.iconCode == 'faqtreatytraders'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" style="width: 85px;height: 82px" 
        width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M2331 4699 c-148 -16 -423 -80 -491 -114 -87 -45 -93 -169 -10 -218
        39 -23 66 -21 184 12 472 137 949 98 1381 -113 168 -83 374 -225 474 -330 l35
        -36 -103 0 c-118 0 -150 -12 -175 -64 -30 -63 -14 -125 41 -162 25 -17 52 -19
        268 -22 274 -4 305 1 343 58 23 34 23 36 20 303 l-3 269 -32 28 c-44 39 -93
        47 -139 23 -51 -26 -74 -73 -74 -150 0 -35 -3 -63 -6 -63 -3 0 -36 28 -74 62
        -199 178 -479 336 -749 424 -269 88 -604 122 -890 93z"/>
        <path d="M849 4281 c-46 -15 -66 -30 -83 -65 -20 -42 -20 -69 -1 -110 24 -49
        61 -66 149 -66 42 0 76 -2 76 -5 0 -3 -32 -42 -71 -88 -86 -99 -199 -267 -267
        -397 -251 -478 -309 -1065 -157 -1590 41 -141 66 -170 144 -170 38 0 56 6 80
        26 49 41 54 81 25 182 -117 401 -112 783 16 1165 76 227 205 455 356 632 l69
        80 5 -97 c6 -110 20 -140 84 -172 32 -16 44 -17 76 -7 21 6 50 25 64 42 l26
        31 0 269 0 269 -27 30 c-17 19 -44 35 -68 40 -48 11 -459 12 -496 1z"/>
        <path d="M2321 3914 c-164 -28 -371 -111 -521 -210 -311 -205 -536 -551 -595
        -914 -19 -122 -19 -338 0 -460 69 -425 349 -801 744 -999 190 -96 385 -141
        611 -141 226 0 421 45 611 141 395 198 675 574 744 999 19 122 19 338 0 460
        -92 563 -562 1033 -1125 1125 -117 19 -354 18 -469 -1z m446 -249 c220 -42
        409 -141 576 -304 169 -164 279 -367 322 -594 19 -103 19 -311 0 -414 -86
        -451 -447 -812 -898 -898 -103 -19 -311 -19 -414 0 -451 86 -812 447 -898 898
        -19 103 -19 311 0 414 85 448 443 808 891 897 95 19 323 20 421 1z"/>
        <path d="M2515 3380 c-54 -22 -84 -86 -85 -180 -1 -44 -2 -45 -53 -69 -68 -33
        -142 -107 -175 -179 -23 -49 -27 -70 -27 -147 0 -108 23 -163 96 -237 57 -57
        120 -90 236 -123 121 -35 140 -43 168 -77 52 -62 15 -142 -77 -168 -47 -13
        -106 1 -136 32 -12 13 -39 42 -60 66 -35 37 -45 42 -82 42 -75 0 -130 -54
        -130 -127 0 -69 95 -181 192 -226 46 -21 47 -23 48 -67 1 -73 17 -121 50 -154
        26 -26 38 -31 80 -31 42 0 54 5 80 31 33 33 49 81 50 154 1 44 2 45 53 69 68
        33 142 107 175 179 23 49 27 70 27 147 0 84 -2 95 -34 153 -58 107 -149 168
        -315 212 -95 25 -128 41 -155 76 -65 83 43 195 158 164 22 -6 50 -22 63 -37
        84 -95 94 -103 138 -103 23 0 55 8 71 17 31 19 59 68 59 105 -1 69 -94 185
        -186 229 l-51 24 -6 73 c-6 81 -22 113 -70 142 -34 21 -68 24 -102 10z"/>
        <path d="M4408 3344 c-34 -18 -58 -62 -58 -105 0 -18 11 -70 25 -116 186 -610
        58 -1268 -342 -1763 -34 -41 -74 -88 -91 -103 l-29 -28 -5 98 c-3 72 -10 106
        -23 126 -35 54 -107 72 -165 42 -57 -29 -60 -49 -60 -330 0 -281 3 -301 60
        -330 24 -12 75 -15 282 -15 233 0 255 2 285 20 43 26 67 73 60 118 -13 79 -64
        112 -173 112 l-66 0 57 62 c387 418 594 1053 535 1639 -18 178 -78 436 -121
        521 -32 63 -109 86 -171 52z"/>
        <path d="M913 1425 c-18 -8 -42 -29 -53 -47 -19 -31 -20 -50 -20 -286 0 -278
        4 -298 60 -327 38 -20 95 -19 131 2 42 25 59 69 59 152 l0 71 83 -71 c237
        -206 558 -368 887 -448 181 -45 285 -56 515 -55 172 0 233 4 339 23 143 25
        321 73 378 102 99 50 86 199 -20 228 -27 8 -51 5 -115 -15 -498 -150 -980
        -117 -1422 96 -161 78 -395 236 -469 319 l-19 21 97 0 c108 0 141 12 170 60
        35 61 6 148 -59 176 -49 20 -495 20 -542 -1z"/>
        </g>
        </svg>
    </span> -->
    <!-- Pooja, 26-jul-23,Tiwan U.S. Global Entry program faq -->
    <!-- <span class="svg-lg text-black" v-if="data.fields.iconCode == 'globalentry'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="96.000000pt" height="105.000000pt" viewBox="0 0 96.000000 105.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,105.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M363 1026 c-85 -28 -143 -81 -143 -131 0 -10 13 -29 30 -45 29 -27
      30 -32 40 -160 11 -147 26 -188 84 -228 69 -47 183 -37 242 22 40 40 50 80 59
      225 7 110 8 115 36 138 57 49 25 120 -73 163 -65 29 -210 37 -275 16z m277
      -51 c63 -35 86 -74 58 -102 -15 -14 -25 -15 -87 -5 -93 16 -193 15 -265 -2
      -54 -13 -59 -13 -77 5 -26 26 -24 41 9 73 51 48 115 67 217 63 77 -2 98 -7
      145 -32z m-7 -140 c9 -4 17 -18 17 -31 l0 -24 -170 0 -170 0 0 24 c0 21 7 26
      43 35 46 11 251 8 280 -4z m7 -153 c0 -92 -16 -107 -108 -107 -55 0 -67 -3
      -70 -17 -3 -16 30 -43 41 -32 3 3 32 11 66 18 l60 12 -17 -28 c-24 -42 -93
      -72 -149 -65 -93 10 -132 65 -140 196 l-6 91 162 0 161 0 0 -68z"/>
      <path d="M428 959 c-26 -17 -46 -35 -43 -39 3 -4 24 -4 47 2 41 9 97 6 132 -8
      9 -3 16 -1 16 4 0 11 -82 72 -97 72 -4 0 -29 -14 -55 -31z"/>
      <path d="M241 394 c-117 -35 -147 -52 -162 -92 -13 -33 -49 -274 -43 -284 3
      -4 203 -8 445 -8 355 0 441 3 445 13 8 22 -34 267 -51 293 -24 37 -51 50 -176
      85 l-116 32 -46 -32 c-25 -17 -49 -31 -54 -31 -4 0 -28 14 -53 30 -25 16 -52
      30 -60 29 -8 0 -66 -16 -129 -35z m179 -20 c38 -25 39 -27 23 -50 -8 -13 -18
      -24 -22 -24 -4 0 -22 16 -41 35 -28 29 -31 37 -20 50 16 19 13 20 60 -11z
      m186 12 c18 -14 18 -16 -18 -53 l-38 -38 -26 26 -25 26 38 26 c46 31 44 31 69
      13z m-290 -23 c7 -10 14 -21 14 -25 0 -3 -27 -15 -61 -27 -44 -14 -61 -17 -64
      -8 -1 7 -5 19 -8 28 -4 13 6 20 46 32 29 9 54 16 56 16 2 1 10 -7 17 -16z
      m400 1 c61 -21 56 -17 45 -46 l-10 -26 -58 21 c-56 20 -59 22 -49 44 13 27 10
      27 72 7z m-540 -69 c8 -42 14 -43 110 -9 l75 27 29 -28 c15 -15 33 -24 38 -21
      5 3 15 0 21 -7 8 -10 7 -19 -4 -33 -10 -13 -14 -45 -15 -101 l0 -83 -180 0
      c-209 0 -189 -18 -163 148 13 84 21 111 40 130 28 28 40 22 49 -23z m679 -8
      c7 -18 18 -70 24 -117 7 -47 15 -95 18 -108 l5 -22 -181 0 -181 0 0 79 c0 63
      -4 83 -20 104 -16 20 -17 27 -6 36 7 6 16 8 20 4 3 -4 19 6 35 21 l29 28 79
      -26 c43 -14 84 -26 90 -26 7 0 17 18 23 40 10 36 13 39 31 29 12 -6 27 -25 34
      -42z m-356 19 c17 -20 -13 -43 -34 -26 -12 10 -13 16 -4 26 6 8 15 14 19 14 4
      0 13 -6 19 -14z m-1 -98 c7 -7 12 -43 12 -91 l0 -78 -27 3 c-27 3 -28 5 -31
      70 -4 88 15 127 46 96z"/>
      <path d="M646 141 c-55 -32 -50 -44 13 -30 39 9 84 6 134 -8 9 -2 17 0 17 6 0
      10 -90 61 -107 61 -4 0 -30 -13 -57 -29z"/>
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'renew'">
      <img src="/assets/img/renew-visapng.png" alt="" width="42" />
    </span> 
    
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'raisedhands'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="119.000000pt" height="128.000000pt" viewBox="0 0 119.000000 128.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M798 1223 c-9 -10 -19 -28 -22 -40 -5 -16 -15 -23 -32 -23 -31 0 -64
      -33 -64 -64 0 -19 -4 -23 -20 -19 -12 3 -29 -2 -40 -12 -18 -17 -20 -32 -20
      -197 0 -139 3 -179 13 -176 9 4 13 52 17 179 5 166 6 174 25 174 18 0 20 -8
      23 -77 2 -60 6 -78 17 -78 12 0 15 21 15 114 0 108 1 115 21 121 12 4 25 3 30
      -2 4 -4 10 -57 11 -117 2 -77 7 -111 16 -114 9 -3 12 30 12 140 0 158 8 186
      48 174 21 -7 22 -12 22 -162 0 -130 2 -154 15 -154 13 0 15 20 15 124 0 100 3
      128 16 140 19 20 29 20 48 0 13 -13 16 -43 16 -176 0 -123 3 -159 13 -155 9 3
      12 46 12 171 0 166 0 168 -25 188 -14 12 -33 18 -48 15 -16 -3 -31 3 -47 19
      -28 28 -66 31 -87 7z"/>
      <path d="M260 980 c-11 -11 -31 -20 -44 -20 -51 0 -57 -19 -54 -181 4 -199 21
      -202 28 -4 5 142 6 150 25 150 19 0 20 -8 25 -114 3 -79 9 -116 18 -119 9 -3
      12 26 12 120 0 90 4 129 14 143 12 16 16 17 30 6 13 -11 16 -36 16 -142 0
      -108 2 -129 15 -129 12 0 15 18 15 100 0 83 3 102 16 107 26 10 34 -16 34
      -115 0 -70 3 -93 13 -90 7 3 13 29 15 71 2 48 7 67 16 67 21 0 26 -24 26 -127
      0 -71 3 -94 13 -91 8 3 13 35 15 102 3 105 -10 146 -46 146 -9 0 -24 15 -32
      33 -11 23 -23 33 -42 35 -16 2 -28 9 -28 18 0 21 -37 54 -60 54 -11 0 -29 -9
      -40 -20z"/>
      <path d="M1031 822 c-26 -28 -62 -54 -83 -61 -42 -14 -98 -72 -98 -102 0 -28
      14 -21 42 21 15 22 39 40 67 51 25 9 61 35 86 62 30 33 51 47 69 47 33 0 33
      -13 0 -70 -14 -25 -46 -96 -71 -158 -25 -63 -56 -126 -69 -142 -23 -27 -24
      -32 -24 -230 0 -157 3 -201 13 -198 9 4 13 54 15 198 2 178 4 196 22 215 11
      12 45 81 75 153 30 73 66 151 80 175 14 24 25 46 25 50 0 17 -36 37 -68 37
      -30 0 -43 -8 -81 -48z"/>
      <path d="M43 673 c-19 -7 -16 -38 10 -91 13 -26 41 -91 61 -144 20 -53 46
      -108 57 -121 17 -22 19 -41 19 -152 0 -97 3 -126 13 -123 8 3 13 41 15 132 2
      120 1 128 -21 159 -14 17 -41 76 -61 130 -20 54 -45 116 -56 137 -25 48 -25
      50 0 50 10 0 32 -16 47 -36 15 -20 47 -44 71 -55 25 -11 50 -31 60 -49 9 -16
      20 -30 24 -30 35 0 -11 77 -61 102 -19 9 -51 35 -73 57 -37 40 -68 49 -105 34z"/>
      <path d="M537 622 c-10 -10 -17 -24 -17 -30 0 -6 -10 -12 -22 -14 -12 -2 -28
      -14 -34 -27 -7 -13 -22 -28 -35 -35 -24 -11 -24 -15 -24 -151 0 -127 2 -145
      24 -190 13 -27 27 -68 30 -89 8 -55 31 -60 31 -7 0 26 -10 62 -27 94 -25 47
      -28 64 -31 186 -3 109 -2 133 9 129 8 -3 15 -17 17 -32 6 -48 27 -22 30 37 2
      41 7 57 17 57 10 0 15 -16 17 -57 2 -33 8 -58 15 -60 9 -3 13 20 15 84 2 70 6
      88 18 88 12 0 16 -18 20 -84 7 -111 28 -123 32 -19 2 57 6 73 18 73 12 0 16
      -20 18 -110 l3 -110 -30 -13 c-35 -16 -65 -57 -56 -80 5 -12 12 -8 36 21 17
      20 37 37 45 37 8 0 32 18 54 40 38 39 68 53 56 28 -3 -7 -25 -61 -49 -120 -23
      -59 -51 -115 -60 -126 -20 -22 -24 -106 -4 -100 6 3 14 18 15 33 2 16 11 41
      21 55 9 14 30 59 46 100 15 41 39 97 53 124 23 47 23 50 6 63 -23 17 -46 16
      -70 -2 -10 -8 -22 -15 -26 -15 -5 0 -8 43 -8 95 0 83 -2 96 -19 105 -11 5 -27
      10 -36 10 -9 0 -23 7 -31 15 -21 20 -47 19 -67 -3z"/>
      </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'form' ">
      <svg version="1.1" viewBox="0 0 1232 1600" width="1280" height="1280" xmlns="http://www.w3.org/2000/svg">
      <path transform="translate(16,16)" d="m0 0h1216v1544h-4v4h-1212v-4h-4v-1512h-4v-12h4v-16h4v-4zm40 44v4h-4v1456h1136v-1460h-1132z" fill="#000002"/>
      <path transform="translate(156,1008)" d="m0 0h928v4h4v36h-4v4h-928v-4h-4v-32h4v-8z" fill="#000002"/>
      <path transform="translate(156,848)" d="m0 0h928v4h4v36h-4v4h-928v-4h-4v-32h4v-8z" fill="#000002"/>
      <path transform="translate(156,688)" d="m0 0h928v4h4v36h-4v4h-928v-4h-4v-32h4v-8z" fill="#000002"/>
      <path transform="translate(928,1152)" d="m0 0h40v4h24v4h12v4h8v4h8v4h8v4h4v4h4v4h4v4h8v4h4v8h4v4h4v4h4v4h4v8h4v8h4v8h4v8h4v16h4v72h-4v12h-4v8h-4v8h-4v8h-4v8h-4v4h-4v4h-4v8h-4v4h-4v4h-4v4h-8v4h-4v4h-8v4h-4v4h-8v4h-12v4h-12v4h-20v4h-44v-4h-20v-4h-12v-4h-8v-4h-8v-4h-4v-4h-8v-4h-4v-4h-4v-4h-4v-4h-4v-4h-4v-4h-4v-4h-4v-8h-4v-4h-4v-8h-4v-4h-4v-8h-4v-12h-4v-12h-4v-68h4v-12h4v-12h4v-8h4v-8h4v-4h4v-8h4v-4h4v-4h4v-4h4v-4h4v-4h4v-4h4v-4h8v-4h4v-4h8v-4h4v-4h12v-4h12v-4h20v-4zm-8 48v4h-8v4h-8v4h-8v4h-4v4h-4v4h-8v4h-4v8h-4v4h-4v8h-4v4h-4v12h-4v12h-4v36h4v16h4v8h4v8h4v4h4v4h4v4h4v4h4v4h4v4h4v4h4v4h8v4h8v4h8v4h56v-4h8v-4h8v-4h8v-4h8v-4h4v-4h4v-4h4v-4h4v-8h4v-4h4v-8h4v-12h4v-20h4v-28h-4v-16h-4v-8h-4v-8h-4v-8h-4v-4h-4v-4h-4v-4h-4v-4h-4v-4h-8v-4h-8v-4h-8v-4h-12v-4h-52z" fill="#000002"/>
      <path transform="translate(296,364)" d="m0 0h44v4h180v4h16v4h12v4h8v4h4v4h8v4h4v4h4v4h4v4h4v4h4v4h4v8h4v8h4v8h4v12h4v20h4v68h-4v16h-16v4h-12v-4h-8v-4h-4v-12h-4v-72h-4v-16h-4v-4h-4v-8h-4v-4h-4v-4h-4v-4h-4v-4h-8v-4h-12v-4h-268v4h-16v4h-8v4h-4v4h-4v4h-4v8h-4v4h-4v8h-4v16h-4v80h-4v4h-20v4h-4v-4h-12v-4h-4v-20h-4v-52h4v-28h4v-8h4v-12h4v-4h4v-8h4v-4h4v-4h4v-4h4v-4h4v-4h4v-4h4v-4h8v-4h4v-4h8v-4h12v-4h16v-4h52v-4z" fill="#000002"/>
      <path transform="translate(360,160)" d="m0 0h40v4h20v4h8v4h8v4h8v4h4v4h4v4h4v4h4v4h4v4h4v8h4v8h4v8h4v16h4v32h-4v12h-4v8h-4v8h-4v4h-4v8h-4v4h-4v4h-4v4h-4v4h-4v4h-4v4h-8v4h-8v4h-16v4h-52v-4h-16v-4h-8v-4h-8v-4h-4v-4h-8v-4h-4v-4h-4v-4h-4v-8h-4v-4h-4v-8h-4v-8h-4v-8h-4v-24h-4v-8h4v-20h4v-8h4v-8h4v-8h4v-4h4v-8h4v-4h8v-4h4v-4h4v-4h8v-4h8v-4h8v-4h16v-4zm0 44v4h-8v4h-4v4h-4v4h-4v4h-4v4h-4v8h-4v8h-4v16h4v12h4v8h4v8h4v4h8v4h4v4h8v4h40v-4h8v-4h8v-4h4v-4h4v-8h4v-4h4v-12h4v-16h-4v-16h-4v-8h-4v-4h-4v-4h-4v-4h-8v-4h-8v-4h-40z" fill="#000002"/>
      <path transform="translate(716,352)" d="m0 0h368v4h4v36h-4v4h-368v-4h-4v-32h4v-8z" fill="#000002"/>
      <path transform="translate(716,512)" d="m0 0h368v4h4v36h-4v4h-368v-16h-4v-16h4v-12z" fill="#000002"/>
      <path transform="translate(156,1168)" d="m0 0h368v4h4v36h-12v4h-360v-4h-4v-4h4v-8h-4v-16h4v-12z" fill="#000002"/>
      <path transform="translate(720,192)" d="m0 0h220v4h4v36h-4v4h-224v-12h-4v-20h4v-8h4v-4z" fill="#000002"/>
      <path transform="translate(980,1264)" d="m0 0h24v4h4v28h-4v8h-4v4h-4v4h-4v4h-4v4h-4v4h-8v4h-4v4h-4v4h-8v4h-4v4h-4v4h-8v4h-4v4h-20v-4h-8v-4h-4v-4h-8v-4h-4v-4h-4v-4h-4v-4h-4v-4h-4v-4h-4v-8h-4v-20h4v-4h4v-4h16v4h8v4h4v4h8v4h12v4h4v-4h8v-4h4v-4h4v-4h8v-4h4v-4h4v-4h4v-4h4v-4h8v-4z" fill="#000002"/>
      <path transform="translate(480,468)" d="m0 0h44v4h4v8h4v52h-4v12h-4v8h-12v4h-24v-4h-8v-4h-4v-4h-4v-16h-4v-40h4v-12h4v-4h4v-4z" fill="#000002"/>
      <path transform="translate(252,468)" d="m0 0h36v12h4v4h-4v4h4v48h-4v16h-36v-4h-4v-20h-4v-44h4v-12h4v-4z" fill="#000002"/>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'family'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="100.000000pt" height="105.000000pt" viewBox="0 0 100.000000 105.000000"
      preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,105.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M642 1010 c-62 -58 -25 -160 58 -160 23 0 44 8 58 20 62 58 25 160
        -58 160 -23 0 -44 -8 -58 -20z m92 -21 c36 -28 33 -73 -6 -102 l-28 -21 -27
        21 c-40 29 -43 74 -7 102 15 11 30 21 34 21 4 0 19 -10 34 -21z" stroke="black" stroke-width="18"  />
        <path d="M226 939 c-33 -39 -33 -79 0 -118 21 -26 33 -31 69 -31 36 0 48 5 69
        31 15 17 26 43 26 59 0 16 -11 42 -26 59 -21 26 -33 31 -69 31 -36 0 -48 -5
        -69 -31z m124 -31 c13 -25 13 -31 0 -55 -21 -38 -81 -45 -104 -11 -20 28 -20
        48 0 76 23 34 83 27 104 -10z"  stroke="black" stroke-width="18" />
        <path d="M550 797 c-29 -10 -37 -19 -44 -52 -5 -22 -10 -41 -10 -42 -1 -1 -13
        -4 -28 -8 -21 -5 -27 -3 -33 15 -4 12 -22 28 -41 36 -42 18 -190 18 -224 1
        -14 -7 -55 -63 -99 -135 -66 -108 -74 -126 -65 -150 5 -15 21 -31 37 -36 23
        -8 31 -6 58 20 17 16 40 44 51 62 11 18 22 31 25 29 2 -3 -10 -60 -27 -127
        -17 -68 -29 -129 -26 -136 3 -7 15 -14 28 -16 22 -3 23 -7 24 -93 2 -124 2
        -122 20 -139 17 -18 79 -22 89 -6 4 7 11 8 18 2 16 -13 369 -13 384 0 8 6 19
        6 32 -1 33 -18 76 -13 100 13 22 23 22 27 19 264 -3 225 1 269 16 206 14 -54
        36 -75 75 -72 58 5 61 32 21 198 -22 93 -41 147 -53 158 -16 14 -43 17 -166
        19 -96 2 -158 -1 -181 -10z m317 -28 c18 -6 26 -30 53 -143 18 -74 30 -142 27
        -150 -4 -9 -15 -16 -26 -16 -20 0 -33 27 -76 158 -34 106 -40 64 -36 -251 3
        -227 1 -301 -9 -312 -18 -22 -67 -19 -80 4 -6 11 -10 89 -10 181 0 125 -3 161
        -12 158 -7 -3 -15 -24 -18 -48 l-5 -44 -23 71 c-34 108 -45 117 -137 121 -87
        5 -149 -9 -160 -36 -25 -60 -55 -159 -55 -179 0 -13 -4 -23 -10 -23 -5 0 -11
        -47 -12 -107 -3 -106 -3 -108 -27 -111 -41 -6 -48 17 -43 127 l5 100 -31 13
        -30 13 38 155 c22 85 39 161 40 168 0 30 -33 2 -92 -78 -63 -84 -98 -107 -106
        -69 -3 18 120 226 146 247 16 12 157 17 198 6 25 -7 59 -60 44 -69 -14 -9 -12
        -77 3 -96 34 -44 83 -49 126 -13 41 34 43 89 6 124 -25 24 -32 63 -16 88 17
        27 263 35 328 11z m-339 -115 c41 -28 18 -104 -31 -104 -53 0 -77 75 -35 104
        12 9 27 16 33 16 6 0 21 -7 33 -16z m54 -196 c18 -15 75 -184 65 -194 -15 -16
        -37 9 -53 60 -10 33 -23 56 -32 56 -11 0 -13 -28 -10 -167 l3 -168 -25 0 c-24
        0 -25 2 -30 83 -7 111 -24 111 -28 0 -3 -86 -3 -88 -27 -88 -14 0 -25 6 -26
        13 0 6 0 83 1 171 1 126 -1 157 -12 154 -7 -3 -20 -29 -29 -58 -17 -55 -34
        -74 -45 -46 -9 22 47 185 65 189 38 11 168 6 183 -5z m-201 -391 c-7 -19 -18
        -27 -35 -27 -31 0 -36 15 -36 116 0 81 1 85 20 79 11 -3 28 -2 37 4 16 9 18 3
        21 -68 1 -43 -2 -90 -7 -104z m224 173 c9 -14 49 -12 63 2 10 10 12 -9 10 -92
        l-3 -105 -31 -3 c-17 -2 -35 3 -41 10 -13 16 -25 198 -13 198 5 0 12 -4 15
        -10z"  stroke="black" stroke-width="18"    />
        </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'shapes'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="119.000000pt" height="110.000000pt" viewBox="0 0 119.000000 110.000000"
      preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,110.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M782 883 l3 -198 186 -3 c150 -2 188 0 198 12 8 9 11 69 9 197 l-3
        184 -198 3 -197 2 2 -197z m358 2 l0 -165 -165 0 -165 0 0 158 c0 87 3 162 7
        165 3 4 78 7 165 7 l158 0 0 -165z" stroke="black" stroke-width="25" />
        <path d="M512 1040 c-70 -25 -108 -50 -161 -104 -31 -32 -42 -50 -37 -62 6
        -15 15 -10 59 34 87 85 211 131 315 116 38 -6 42 -4 42 15 0 20 -5 21 -82 21
        -56 -1 -101 -7 -136 -20z" stroke="black" stroke-width="25" />
        <path d="M125 720 c-64 -107 -105 -186 -101 -195 5 -13 37 -15 219 -15 160 0
        217 3 224 13 12 15 -200 377 -221 377 -7 0 -62 -81 -121 -180z m209 -19 c48
        -79 85 -145 83 -147 -2 -3 -81 -3 -175 -2 l-172 3 88 147 c48 80 88 145 88
        145 1 -1 41 -67 88 -146z" stroke="black" stroke-width="25" />
        <path d="M1037 598 c-10 -95 -44 -166 -114 -237 -35 -36 -61 -72 -58 -79 7
        -19 32 -3 93 62 62 66 97 136 111 225 11 67 8 81 -13 81 -9 0 -15 -19 -19 -52z" stroke="black" stroke-width="25" />
        <path d="M260 471 c0 -26 75 -135 113 -165 23 -18 35 -22 44 -14 10 8 0 24
        -45 73 -32 34 -64 76 -71 93 -15 35 -41 43 -41 13z" stroke="black" stroke-width="25" />
        <path d="M541 409 c-62 -32 -101 -96 -101 -166 0 -174 195 -261 329 -147 94
        81 83 232 -20 301 -58 38 -146 43 -208 12z m185 -40 c46 -28 78 -98 70 -152
        -25 -156 -234 -187 -304 -45 -19 38 -22 56 -17 89 9 50 63 115 109 129 42 12
        103 4 142 -21z" stroke="black" stroke-width="25" />
        </g>
      </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'inhand'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="100.000000pt" height="114.000000pt" viewBox="0 0 100.000000 114.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,114.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M437 1116 c-222 -60 -252 -377 -45 -480 100 -50 212 -32 295 49 41
        40 55 62 68 109 41 141 -36 279 -178 321 -60 18 -77 18 -140 1z m178 -48 c110
        -58 153 -206 92 -311 -82 -140 -266 -158 -369 -38 -138 162 -3 403 207 371 22
        -4 54 -14 70 -22z" stroke="black" stroke-width="25" />
        <path d="M506 1043 c-3 -3 -6 -14 -6 -23 0 -10 -13 -23 -30 -30 -35 -14 -48
        -50 -32 -86 8 -16 25 -27 56 -35 58 -14 82 -39 66 -68 -13 -25 -71 -29 -90 -6
        -17 21 -42 19 -38 -2 2 -10 18 -25 35 -33 22 -10 33 -22 33 -37 0 -14 6 -23
        15 -23 9 0 15 9 15 23 0 13 9 26 22 32 12 6 29 22 38 38 23 41 -1 77 -65 98
        -59 19 -79 44 -51 65 29 21 60 17 86 -11 15 -16 27 -22 33 -16 13 13 -16 57
        -43 66 -11 3 -20 15 -20 25 0 20 -13 33 -24 23z" stroke="black" stroke-width="25" />
        <path d="M27 454 c-4 -4 -7 -104 -7 -221 l0 -214 88 3 87 3 3 40 3 40 161 -3
        c183 -4 312 8 478 45 134 29 148 35 156 69 11 45 -18 64 -100 64 -87 0 -116 7
        -109 26 3 8 -2 25 -10 37 -12 19 -38 29 -139 52 l-124 28 -145 -27 c-79 -14
        -149 -26 -156 -26 -7 0 -13 18 -15 43 l-3 42 -80 3 c-45 1 -84 0 -88 -4z m141
        -216 l2 -188 -60 0 -60 0 0 190 0 191 58 -3 57 -3 3 -187z m468 125 c105 -24
        114 -28 114 -50 0 -27 -1 -27 -132 -11 -86 11 -104 10 -153 -6 -33 -10 -55
        -23 -55 -32 0 -18 6 -18 65 3 43 14 60 15 139 4 50 -7 149 -15 219 -18 127 -6
        152 -13 126 -38 -18 -17 -175 -53 -308 -71 -109 -14 -347 -19 -414 -8 l-38 7
        3 96 3 96 140 26 c77 15 148 27 159 28 10 0 70 -11 132 -26z" stroke="black" stroke-width="25" />
        </g>
        </svg>
    </span>
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'resident'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="123.000000pt" height="73.000000pt" viewBox="0 0 123.000000 73.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,73.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M16 694 c-14 -13 -16 -56 -16 -315 0 -188 4 -308 10 -320 10 -18 27
        -19 585 -19 315 0 580 3 589 6 14 5 16 43 16 323 0 233 -3 320 -12 329 -9 9
        -153 12 -584 12 -507 0 -574 -2 -588 -16z m1154 -319 l0 -305 -565 0 -565 0 0
        305 0 305 565 0 565 0 0 -305z"/>
        <path d="M302 580 c-27 -11 -51 -62 -44 -96 6 -34 48 -64 89 -64 85 0 117 117
        42 155 -32 17 -54 18 -87 5z m76 -36 c40 -28 17 -94 -34 -94 -48 0 -70 55 -37
        92 20 22 42 23 71 2z"/>
        <path d="M647 564 c-17 -18 14 -24 114 -24 90 0 109 3 109 15 0 12 -19 15
        -108 15 -60 0 -112 -3 -115 -6z"/>
        <path d="M647 444 c-19 -19 24 -24 219 -24 184 0 214 2 214 15 0 13 -30 15
        -213 15 -118 0 -217 -3 -220 -6z"/>
        <path d="M178 361 c-29 -26 -32 -35 -36 -97 -2 -38 -8 -74 -13 -80 -5 -6 -6
        -14 -2 -17 3 -4 102 -7 219 -7 l212 0 -5 68 c-6 79 -28 132 -63 149 -16 8 -71
        13 -152 13 -126 0 -128 0 -160 -29z m312 -21 c16 -16 20 -33 20 -85 0 -58 -2
        -65 -20 -65 -17 0 -20 7 -20 50 0 38 -4 50 -15 50 -11 0 -15 -12 -15 -50 l0
        -50 -95 0 -95 0 0 50 c0 38 -4 50 -15 50 -11 0 -15 -12 -15 -50 0 -47 -1 -50
        -26 -50 -26 0 -26 0 -22 66 6 98 17 104 174 104 111 0 126 -2 144 -20z"/>
        <path d="M647 324 c-19 -19 24 -24 219 -24 184 0 214 2 214 15 0 13 -30 15
        -213 15 -118 0 -217 -3 -220 -6z"/>
        <path d="M717 204 c-19 -19 21 -24 184 -24 152 0 179 2 179 15 0 13 -26 15
        -178 15 -98 0 -182 -3 -185 -6z"/>
        </g>
        </svg>
    </span> -->
    
    <!-- New ACS svg added -->
    <!-- <span class="svg-lg text-black" v-if="data.fields.iconCode == 'acs'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"  width="114.000000pt" height="114.000000pt" viewBox="0 0 114.000000 114.000000"  preserveAspectRatio="xMidYMid meet">  <g transform="translate(0.000000,114.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M512 1123 c-17 -7 -42 -57 -42 -84 0 -12 16 -36 35 -55 31 -29 35 -38 35 -83 0 -34 -4 -51 -12 -51 -29 0 -88 -22 -123 -45 l-37 -26 -36 33 c-32 27 -37 38 -37 76 -1 36 -6 49 -28 68 -86 73 -194 -53 -111 -128 28 -25 66 -31 89 -15 17 14 23 12 62 -20 l43 -35 -25 -30 c-14 -17 -33 -57 -42 -89 l-16 -59 -43 0 c-34 0 -49 6 -72 30 -34 33 -59 37 -101 15 -47 -24 -56 -83 -20 -129 37 -47 128 -29 143 29 6 22 12 25 50 25 l43 0 12 -53 c6 -29 22 -69 35 -88 l24 -35 -33 -27 c-29 -23 -37 -25 -64 -16 -89 31 -155 -81 -85 -142 30 -27 60 -31 92 -15 34 18 56 63 47 97 -5 19 1 31 25 54 26 25 33 28 48 17 37 -27 118 -62 145 -62 25 0 27 -3 27 -45 0 -32 -4 -45 -14 -45 -22 0 -56 -49 -56 -81 0 -36 37 -77 76 -85 46 -9 94 35 94 85 0 38 -31 81 -59 81 -8 0 -11 14 -9 42 3 41 4 43 45 50 48 8 79 22 111 51 l22 21 30 -29 c28 -27 30 -33 24 -76 -6 -42 -3 -50 19 -73 54 -54 147 -18 147 57 0 58 -63 102 -113 80 -19 -9 -27 -5 -53 26 l-31 36 22 30 c25 34 45 87 45 121 0 22 4 24 50 24 42 0 50 -3 50 -18 0 -28 42 -62 77 -62 45 0 62 9 78 41 22 42 18 67 -14 100 -40 40 -83 39 -121 -1 -23 -25 -36 -30 -74 -30 -43 0 -46 2 -46 25 0 33 -24 90 -55 131 l-24 31 37 36 c28 27 41 34 52 27 45 -29 120 18 120 75 0 82 -95 121 -147 60 -21 -23 -24 -36 -20 -68 5 -34 1 -45 -26 -77 l-31 -38 -36 24 c-20 13 -59 30 -88 36 l-52 13 0 52 c0 30 5 53 10 53 6 0 22 11 35 25 69 68 -11 175 -103 138z m88 -38 c18 -22 15 -66 -6 -82 -56 -41 -127 32 -78 81 20 20 68 21 84 1z m318 -131 c32 -22 27 -73 -9 -93 -24 -13 -29 -13 -53 2 -34 22 -36 69 -4 91 28 20 38 20 66 0z m-668 -24 c25 -25 25 -55 0 -80 -27 -27 -46 -25 -76 5 -18 19 -23 31 -19 48 15 47 61 61 95 27z m295 -170 c0 -66 -5 -70 -63 -49 -28 10 -31 13 -21 32 16 30 60 77 73 77 7 0 11 -24 11 -60z m89 12 c34 -47 30 -57 -26 -67 l-38 -7 0 62 c0 53 2 61 17 58 9 -2 31 -22 47 -46z m-164 34 c0 -3 -9 -21 -21 -40 -18 -31 -23 -34 -40 -23 -26 16 -24 22 14 46 31 20 47 26 47 17z m224 -20 l39 -23 -24 -16 c-12 -9 -23 -16 -24 -14 -1 1 -11 19 -23 40 -25 43 -21 45 32 13z m-297 -64 c22 -16 22 -19 10 -82 l-12 -65 -48 0 -49 0 5 37 c5 38 51 128 65 128 4 0 17 -8 29 -18z m387 -34 c14 -29 28 -65 32 -80 l6 -28 -56 0 -56 0 0 33 c0 17 -4 46 -9 64 -8 27 -6 34 12 47 35 24 44 19 71 -36z m-268 -8 c22 0 24 -4 24 -50 l0 -50 -55 0 c-61 0 -62 2 -49 82 6 34 8 36 31 27 13 -5 35 -9 49 -9z m168 -52 l7 -48 -60 0 -61 0 0 50 c0 50 0 50 33 50 17 0 39 5 47 10 19 12 25 -1 34 -62z m-552 -35 c36 -32 13 -95 -35 -95 -36 0 -57 19 -57 53 0 52 53 77 92 42z m932 -5 c23 -32 20 -54 -10 -77 -34 -27 -40 -26 -69 4 -30 29 -31 49 -5 75 27 27 65 26 84 -2z m-657 -105 c11 -64 11 -68 -10 -82 -12 -9 -26 -16 -31 -16 -14 0 -56 85 -63 128 l-6 37 50 0 49 0 11 -67z m133 19 l0 -48 -46 -12 c-26 -7 -49 -11 -51 -8 -2 2 -7 29 -10 60 l-6 56 57 0 56 0 0 -48z m145 6 c-10 -66 -16 -80 -30 -74 -8 3 -30 8 -49 12 -35 6 -36 7 -36 55 l0 49 61 0 61 0 -7 -42z m135 34 c0 -24 -30 -104 -49 -131 -21 -30 -22 -30 -51 -13 -20 11 -28 22 -24 32 4 8 9 39 12 68 l4 52 54 0 c30 0 54 -4 54 -8z m-277 -241 c-6 -10 -53 32 -71 64 l-22 36 23 8 c59 23 62 21 67 -44 3 -33 4 -62 3 -64z m115 104 c12 -12 -59 -105 -80 -105 -4 0 -8 29 -8 64 l0 64 42 -10 c23 -5 44 -11 46 -13z m-204 -58 c14 -20 23 -37 20 -37 -12 0 -84 44 -84 51 0 8 33 30 37 25 1 -1 13 -18 27 -39z m259 29 c20 -15 14 -22 -41 -50 l-33 -17 23 40 c26 46 26 46 51 27z m-463 -86 c25 -25 25 -55 0 -80 -27 -27 -46 -25 -76 5 -18 19 -23 31 -19 48 15 47 61 61 95 27z m672 -17 c20 -18 24 -63 6 -81 -20 -20 -76 -15 -88 7 -14 28 -12 52 7 73 20 22 51 23 75 1z m-330 -120 c35 -31 12 -103 -34 -103 -24 0 -58 35 -58 60 0 24 34 60 57 60 9 0 25 -7 35 -17z"/>
        </g> 
      </svg>  
    </span>
    
    <span class="svg-lg text-black" v-if="data.fields.iconCode == 'l1blanket'">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="91.000000pt" height="96.000000pt" viewBox="0 0 91.000000 96.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)"
      fill="#000000" stroke="none">
      <path d="M169 911 c-17 -18 -29 -40 -29 -56 0 -38 50 -85 90 -85 22 0 41 9 61
      29 40 40 39 81 -2 115 -41 35 -83 34 -120 -3z m103 -18 c26 -23 23 -59 -7 -79
      -54 -35 -116 18 -81 71 19 29 60 34 88 8z"/>
      <path d="M155 707 l-36 -36 7 -153 c9 -231 30 -261 190 -266 106 -4 94 7 115
      -112 6 -36 18 -73 26 -82 21 -24 56 -23 78 2 18 20 18 25 1 133 -9 62 -20 133
      -23 160 l-5 47 161 0 161 0 0 -174 c0 -118 4 -177 11 -182 23 -14 29 25 29
      189 0 104 4 167 10 167 6 0 10 7 10 15 0 9 -9 15 -25 15 -14 0 -25 2 -25 5 0
      3 16 37 35 75 19 38 35 74 35 80 0 6 -45 10 -120 10 l-120 0 -42 -85 -42 -85
      -63 0 c-60 0 -91 -14 -59 -26 19 -7 22 -58 4 -52 -7 3 -44 13 -81 23 l-68 18
      7 81 c3 45 8 83 10 85 2 2 26 -6 53 -18 55 -23 186 -30 222 -11 23 13 26 62 4
      80 -8 6 -44 15 -80 20 -35 4 -78 16 -94 27 -115 73 -126 77 -188 81 -61 4 -64
      3 -98 -31z m200 -33 c26 -16 60 -37 76 -47 16 -11 59 -23 95 -27 73 -9 79 -12
      71 -35 -11 -26 -134 -20 -209 10 -34 14 -67 25 -73 25 -9 0 -15 -35 -20 -111
      -4 -61 -5 -112 -3 -115 3 -2 43 -15 89 -29 46 -14 91 -33 100 -44 20 -24 45
      -209 31 -223 -22 -22 -40 1 -51 65 -6 35 -11 71 -11 79 0 9 -8 26 -18 38 -17
      20 -26 22 -103 21 -68 -1 -90 2 -116 18 -41 26 -49 59 -57 229 -5 133 -5 134
      20 159 22 22 32 25 78 21 36 -3 69 -14 101 -34z m487 -161 c-15 -32 -31 -64
      -35 -70 -10 -16 -177 -18 -177 -3 0 6 14 37 30 70 l30 60 90 0 89 0 -27 -57z"/>
      <path d="M46 722 c-3 -5 8 -123 24 -262 17 -139 30 -254 30 -256 0 -2 33 -4
      73 -6 l72 -3 3 -68 3 -67 -41 0 c-29 0 -40 -4 -40 -15 0 -12 17 -15 90 -15 73
      0 90 3 90 15 0 10 -11 15 -35 15 l-35 0 0 65 0 65 59 0 c51 0 83 12 69 25 -2
      2 -66 7 -141 11 l-137 7 -5 31 c-3 17 -14 112 -25 211 -11 99 -23 197 -26 218
      -5 35 -17 47 -28 29z"/>
      </g>
      </svg>
    </span>     -->
    <div @click="onButtonClick($event)" class="text-bold card-link" tabindex="0">
      <rich-text-renderer :data="data.fields.cardBody"></rich-text-renderer>
    </div>
  </div>
</template>
<script>
import { urlCountryCode } from "@/helpers/url";
import { getCountryName } from "@/store/api";
import { getDataByFieldSlug } from "@/store/api";

function onButtonClick(event) {
  this.additionaldata.faqSection.$emit(
    "show-question",
    this.data.fields.cardSlug,
    this.$parent
  );
  this.additionaldata.faqSection.$emit('card-click');
  var elmnt = document.getElementById("faq-search-results-count");
elmnt.scrollIntoView();
}
export default {
  name: "faq-card",
  props: ["data", "additionaldata"],
  data() {
    return {
      StyleClass: "",
      countryCode: "",
      country: "",
      dataLoaded: false,
      cgiDataLoaded: false,
        pageData: {},
        cgiData: {}
    };
  },
  methods: {
    onButtonClick: onButtonClick,
  },
  created() {
    this.countryCode = urlCountryCode();
    getCountryName(this.countryCode).then((country) => {
        this.country = country;
    });
    getDataByFieldSlug("blockOfText", "faq-icons", "global").then((pageData) => {
        this.dataLoaded = true;
        if (!pageData) {
          console.log('404');
        }
        this.pageData = pageData;
      });

  }
};

</script>



<style scoped lang="scss">
  .footer-text {
    .rich-text {
      ::v-deep p { 
        font-size: 0.86507rem; 
      }
    }
  }
</style>


<style lang="scss" scoped>
.usa-link:hover {
  color: #0071BC;
  display: block;
}

.card-link {
  cursor: pointer;
  ::v-deep span {
    display: flex;
    width: auto;
    justify-content: center;
    height: auto;
  }
  ::v-deep p {
    margin: 0;
    a {
      text-decoration: none;
    }
  }
}

</style>